// Mock data for Let’s Print – moo.com style replica

export const HERO_SLIDES = [
  {
    id: 1,
    eyebrow: "BUSINESS CARDS",
    title: "Make Your First Impression Unforgettable.",
    subtitle: "Business Cards with Gloss finish that make your business impossible to ignore.",
    cta: "Shop Business Cards",
    href: "/category/business-cards",
    image: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/18eekx2g_Gemini_Generated_Image_95d7qc95d7qc95d7.jpg",
    bg: "#EDE6DC",
  },
  {
    id: 2,
    eyebrow: "CUSTOM PRODUCT LABELS",
    title: "Labels that sell your bottle.",
    subtitle:
      "From kremas and epis jars to cold-pressed juice, turmeric shots and sauce bottles — we print product labels that make small brands look big.",
    cta: "Shop Custom Labels",
    href: "/category/labels-stickers",
    image:
      "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/3u3f7edz_image.png",
    bg: "#F1ECE3",
  },
  {
    id: 3,
    eyebrow: "EVENT PRINTING",
    title: "Branding You're Proud to Show Off.",
    subtitle: "Full event setups — get custom promotional gear that elevates your business.",
    cta: "Shop for Event Printing",
    href: "/category/event-printing",
    image: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/a3nw3yx4_image.png",
    bg: "#E9E2D2",
  },
];

export const PROMISES = [
  { icon: "Truck", title: "Local delivery available", desc: "Free local delivery in select areas. Order before 2 PM." },
  { icon: "Plane", title: "Shipping USA & Bahamas", desc: "We ship to all 50 states & the Bahamas, fast." },
  { icon: "Headphones", title: "Personalized support", desc: "Real designers, real humans, ready to help." },
  { icon: "BadgeDollarSign", title: "Lowest design price guaranteed", desc: "Find it cheaper? We'll match it. Promise." },
];

export const TOP_CATEGORIES = [
  {
    slug: "business-cards",
    name: "Business Cards",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/business-cards.png`,
  },
  {
    slug: "marketing-material",
    name: "Marketing Material",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/marketing-material.png`,
  },
  {
    slug: "signs-banners-poster",
    name: "Signs & Banners",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/signs-banners-poster.png`,
  },
  {
    slug: "labels-stickers",
    name: "Labels & Stickers",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/labels-stickers.png`,
  },
  {
    slug: "event-printing",
    name: "Event Printing",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/event-printing.png`,
  },
  {
    slug: "print-stationery",
    name: "Print Stationery",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/print-stationery.png`,
  },
  {
    slug: "digital",
    name: "Digital Products",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/digital.png`,
  },
  {
    slug: "pre-clothes-printing",
    name: "Apparel & T-Shirts",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/pre-clothes-printing.png`,
  },
];

export const NAV_CATEGORIES = [
  {
    label: "Business Cards",
    slug: "business-cards",
    items: [
      { label: "Regular Business Cards", slug: "regular-business-card" },
      { label: "Spot UV Business Cards", slug: "spot-uv-business-cards" },
      { label: "Extra Thick Business Cards", slug: "extra-thick-business-cards" },
      { label: "Plastic Business Cards", slug: "plastic-business-cards" },
      { label: "Raised Foil Business Cards", slug: "raised-foil-business-cards" },
    ],
  },
  {
    label: "Marketing Material",
    slug: "marketing-material",
    // Mega-menu: 3 grouped columns rendered side-by-side. The Header component
    // detects the `sections` array and switches from single-column to multi-
    // column layout automatically.
    sections: [
      {
        title: "Marketing Materials",
        items: [
          { label: "Flyers", slug: "flyers" },
          { label: "EDDM Postcards", slug: "eddm-postcards" },
          { label: "Car Magnets", slug: "car-magnets" },
          { label: "Brochures", slug: "brochures" },
          { label: "Retractable Banner", slug: "retractable-banner" },
        ],
      },
      {
        title: "Event Printing",
        items: [
          { label: "Retractable Banner", slug: "retractable-banner" },
        ],
      },
      {
        title: "All In One Printing",
        items: [
          { label: "AIO Business Starter", slug: "aio-business-starter" },
        ],
      },
      {
        title: "Gang Sheet Printing",
        items: [
          { label: "DTF Gang Sheet", slug: "dtf-gang-sheet" },
          { label: "UV Sticker Gang Sheet", slug: "uv-sticker-gang-sheet" },
        ],
      },
    ],
    // Keep `items` as a flat fallback so legacy code paths (CategoryPage,
    // search, etc.) still see a single list when they don't know about
    // sections. This is the union of the three columns above.
    items: [
      { label: "Flyers", slug: "flyers" },
      { label: "EDDM Postcards", slug: "eddm-postcards" },
      { label: "Car Magnets", slug: "car-magnets" },
      { label: "Brochures", slug: "brochures" },
      { label: "Retractable Banner", slug: "retractable-banner" },
      { label: "AIO Business Starter", slug: "aio-business-starter" },
      { label: "DTF Gang Sheet", slug: "dtf-gang-sheet" },
      { label: "UV Sticker Gang Sheet", slug: "uv-sticker-gang-sheet" },
    ],
  },
  {
    label: "Signs & Banners",
    slug: "signs-banners-poster",
    items: [
      { label: "Outdoor Banner", slug: "outdoor-banner" },
      { label: "Indoor Banner", slug: "indoor-banner" },
    ],
  },
  {
    label: "Labels & Stickers",
    slug: "labels-stickers",
    items: [
      { label: "Stickers", slug: "waterproof-vinyl-labels" },
      { label: "Labels", slug: "standard-labels" },
    ],
  },
  {
    label: "Print Stationery",
    slug: "print-stationery",
    items: [
      { label: "Carbonless Forms", slug: "carbonless-forms" },
    ],
  },
  {
    label: "Apparel & T-Shirts",
    slug: "pre-clothes-printing",
    items: [],
  },
  {
    label: "Digital",
    slug: "digital",
    items: [
      { label: "QR Code",                 to: "/contact?service=qr-code" },
      { label: "NFC Products",            to: "/contact?service=nfc-products" },
      { label: "E Business Card",         to: "/contact?service=e-business-card" },
      { label: "1 Page Website",          to: "/contact?service=1-page-website" },
      { label: "Website Development",     to: "/contact?service=website-development" },
      { label: "E-commerce Website",      to: "/contact?service=ecommerce-website" },
      { label: "Social Media Management", to: "/contact?service=social-media-management" },
      { label: "Virtual Assistant",       to: "/contact?service=virtual-assistant" },
      { label: "AI Application",          to: "/contact?service=ai-application" },
      { label: "Domain & Hosting",        to: "/contact?service=domain-hosting" },
    ],
  },
];

// Business card pricing tiers (used by BC products)
const BC_QUANTITIES = [
  { qty: 50, perCard: 0.46 },
  { qty: 100, perCard: 0.39 },
  { qty: 250, perCard: 0.32 },
  { qty: 500, perCard: 0.27 },
  { qty: 1000, perCard: 0.23 },
  { qty: 2500, perCard: 0.19 },
  { qty: 5000, perCard: 0.16 },
];

// All products from letsprint.ai
export const PRODUCTS = [
  {
    slug: "regular-business-card",
    name: "Regular Business Cards",
    category: "business-cards",
    type: "business-card",
    tagline: "The everyday card. Quietly impressive.",
    description:
      "Printed on a substantial 16pt card stock with rich, full-color print on both sides. Pick your size, finish and corners — we take it from there.",
    longDescription:
      "Every business card you hand out should instantly make an impression, setting you apart from the competition. Elevate your brand with our premium 16pt cardstock and optional gloss finish, ensuring your cards stand out and leave a lasting impact.",
    fromPrice: 34.99,
    minQty: 100,
    image: "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/767344900eaf0cb9aaa21395b9c79eab40f2942ae9d7bb63b49189fb911efdea.jpeg",
    images: [
      "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/767344900eaf0cb9aaa21395b9c79eab40f2942ae9d7bb63b49189fb911efdea.jpeg",
      "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/c61ed53bff387aa94b49be45ad1173e668756d7044b485d19941ab51cc4d72a6.jpeg",
      "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/81f2755ed0caa3b9e4314303fcb92c715b0ae8bad90585d39831cac9a277ca26.jpeg",
    ],
    sizes: [
      { id: "standard", label: "Standard", dim: '2.0″ x 3.5″', shape: "rect-h", multiplier: 1.0 },
      { id: "square", label: "Square", dim: '2.56″ x 2.56″', shape: "square", multiplier: 1.0 },
    ],
    finishes: [
      { id: "matte", label: "Matte", desc: "Smooth, shine-free finish with a refined touch." },
      { id: "gloss", label: "Gloss", desc: "Glassy shine that makes color and photos sing." },
    ],
    corners: [
      { id: "square", label: "Square", desc: "Sharp 90° corners. Crisp and confident." },
      { id: "rounded", label: "Rounded", desc: "Soft, friendly corners with a modern feel." },
    ],
    quantityTiers: [
      { qty: 100, base: 34.99, roundedAdd: 8.0 },
      { qty: 250, base: 44.99, roundedAdd: 10.0 },
      { qty: 500, base: 59.99, roundedAdd: 15.0 },
      { qty: 1000, base: 64.99, roundedAdd: 20.0 },
      { qty: 2500, base: 99.99, roundedAdd: 25.0 },
      { qty: 5000, base: 149.99, roundedAdd: 30.0 },
      { qty: 10000, base: 249.99, roundedAdd: 60.0 },
    ],
    features: [
      "16pt premium coated stock",
      "Full color, double-sided print at no extra cost",
      "Standard or square shape at no extra cost",
      "Personalized support from a real human, not a bot",
    ],
  },
  {
    slug: "extra-thick-business-cards",
    name: "Extra Thick Business Cards",
    category: "business-cards",
    type: "business-card",
    tagline: "Heavier in the hand. Heavier in the memory.",
    description:
      "Substantial 32pt triple-layer stock with an unmistakable weight and a hidden pop of painted-edge color.",
    longDescription:
      "Our Extra Thick Business Cards are built from a 32pt triple-layer stock — nearly twice the thickness of standard cards — with a matte uncoated finish that feels like a small luxury object every time you hand one over. Pick from 15 painted edge colors, including metallic shimmer options, to add a hidden brand accent that customers never forget.",
    fromPrice: 149.99,
    minQty: 100,
    designFee: 50,
    image: "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/674d06c58e6566595975fa478d57c9ff8580488728e23f2e886d8645bf546941.jpeg",
    images: [
      "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/674d06c58e6566595975fa478d57c9ff8580488728e23f2e886d8645bf546941.jpeg",
      "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/a1749a1da9db4ab81a159a6a991d136d053a55d723ec734af9a68d560f376c5b.jpeg",
      "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/180d46a88458285d5bcf65de1676eb5fd66beb4977e87225c115c20cd656662d.jpeg",
    ],
    sizes: [
      { id: "standard", label: "Standard", dim: '2.0″ x 3.5″', shape: "rect-h", multiplier: 1.0 },
      { id: "square", label: "Square", dim: '2.56″ x 2.56″', shape: "square", multiplier: 1.15 },
    ],
    finishes: [
      { id: "matte", label: "Matte", desc: "Smooth, shine-free uncoated finish with a refined touch." },
    ],
    corners: [
      { id: "square", label: "Square", desc: "Sharp 90° corners. Crisp and confident." },
    ],
    edgeColors: [
      { id: "white", label: "White", hex: "#FFFFFF", metallic: false },
      { id: "yellow", label: "Yellow", hex: "#FFD43B", metallic: false },
      { id: "metallic-blue", label: "Metallic Blue", hex: "#1E5BDB", metallic: true },
      { id: "turquoise", label: "Turquoise", hex: "#1CB5B0", metallic: false },
      { id: "red", label: "Red", hex: "#E53935", metallic: false },
      { id: "black", label: "Black", hex: "#111111", metallic: false },
      { id: "pink", label: "Pink", hex: "#E84393", metallic: false },
      { id: "orange", label: "Orange", hex: "#F7691B", metallic: false },
      { id: "blue", label: "Blue", hex: "#1E60C2", metallic: false },
      { id: "metallic-purple", label: "Metallic Purple", hex: "#7B3FA1", metallic: true },
      { id: "metallic-yellow", label: "Metallic Yellow", hex: "#E6B800", metallic: true },
      { id: "metallic-gold", label: "Metallic Gold", hex: "#C9A227", metallic: true },
      { id: "metallic-green", label: "Metallic Green", hex: "#2E8B57", metallic: true },
      { id: "brown", label: "Brown", hex: "#6B3F2A", metallic: false },
      { id: "metallic-orange", label: "Metallic Orange", hex: "#E07A1F", metallic: true },
    ],
    quantityTiers: [
      { qty: 100, base: 149.99 },
      { qty: 250, base: 179.99 },
      { qty: 500, base: 199.99 },
      { qty: 1000, base: 249.99 },
    ],
    productionOptions: [
      {
        id: "regular",
        label: "Regular",
        days: "10–12 Business Days",
        multiplier: 1.0,
        desc: "Standard turnaround for Extra Thick cards. Painted-edge cards take a little longer to produce — ships within 10–12 business days of design approval.",
        icon: "Clock",
      },
    ],
    features: ["32pt triple-layer uncoated stock", "Painted edge in 15 colors", "Matte uncoated finish", "Made in the USA"],
    faqs: [
      {
        q: "What makes Extra Thick Business Cards different?",
        a: "These cards are built on a 32pt triple-layer uncoated stock — nearly twice as thick as our regular 16pt card — with a hand-painted edge in the color of your choice. The weight, the matte feel and that hidden pop of color make them unforgettable.",
      },
      {
        q: "What edge colors can I choose from?",
        a: "15 painted edge colors: White, Yellow, Metallic Blue, Turquoise, Red, Black, Pink, Orange, Blue, Metallic Purple, Metallic Yellow, Metallic Gold, Metallic Green, Brown and Metallic Orange. The metallic options have a subtle shimmer that catches the light beautifully.",
      },
      {
        q: "What's the minimum order and what does it cost?",
        a: "Extra Thick Business Cards are available in 4 quantity tiers:\n• 100 cards — $149.99\n• 250 cards — $179.99\n• 500 cards — $199.99\n• 1,000 cards — $249.99\nNo other quantities are available for this product.",
      },
      {
        q: "How long until my cards arrive?",
        a: "Production takes 10–12 business days from design approval, plus shipping. Painted-edge cards require extra hand-finishing time, so Express production is not available on this product. If you need cards faster, our Regular Business Cards ship in 5–6 business days.",
      },
      {
        q: "What finish options are available?",
        a: "Extra Thick Business Cards are only available in a Matte uncoated finish. The uncoated paper is what allows the painted edge to absorb evenly and look its best. Gloss and Soft Touch are not offered on this product.",
      },
      {
        q: "Can I get rounded corners on Extra Thick cards?",
        a: "No — Extra Thick cards are only available with sharp square 90° corners. The thickness of the 32pt stock and the painted edge process require a clean straight cut. If you'd like rounded corners, our Regular Business Cards support that option.",
      },
      {
        q: "Are Extra Thick cards printed on both sides?",
        a: "Yes. Full-color, double-sided printing is included on every order at no extra cost. Use the back for a tagline, social handle, QR code or a completely different design.",
      },
      {
        q: "Can your team design the cards for me?",
        a: "Absolutely. Pick the \"Let’s Print will design it for me\" option at checkout for a one-time $50 design fee. Our in-house team will craft a layout from your logo and brand notes, with two rounds of revisions included.",
      },
      {
        id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "We back our work with a strict Reprint Promise. If you contact us and send a photo within 5 days of delivery, we will happily reprint your order — no questions asked — if:\n• It's damaged: The items arrived bent, torn, or damaged in transit.\n• It's a production error: The final print does not match the artwork you approved or uploaded.\n\nNote: Our promise does not cover blurriness or low-quality issues resulting from low-resolution files provided or approved by the customer.",
      },
      {
        q: "What file format should I upload?",
        a: "Print-ready PDFs are best, but we also accept high-resolution PNG, JPG, AI and PSD files. Include 0.125\" bleed on all sides at 300 dpi. Because these cards have a painted edge, do not place any text or critical artwork closer than 0.25\" from the trim.",
      },
    ],
  },
  {
    slug: "plastic-business-cards",
    name: "Plastic Business Cards",
    category: "business-cards",
    type: "business-card",
    tagline: "Indestructible. Unmistakable.",
    description:
      "Waterproof, tear-proof 20pt Plastic cards with vivid color and an optional frosted or clear finish.",
    longDescription:
      "Plastic Business Cards are printed on durable 20pt Plastic that bends without breaking and shrugs off rain, coffee and back-pocket abuse. Choose opaque white, frosted, or transparent stock — perfect for VIP, loyalty and membership cards.",
    fromPrice: 169.99,
    minQty: 100,
    designFee: 50,
    cornersBeforeFinish: true,
    image: "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/4785535697d8c42fe7f85644df4cb43433ad2cdd28a7073bfdb8f30b8bc2ac4b.jpeg",
    images: [
      "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/4785535697d8c42fe7f85644df4cb43433ad2cdd28a7073bfdb8f30b8bc2ac4b.jpeg",
      "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/r5a9ixij_Plastic%20BC%202.PNG",
      "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/1eaaa3471f6a6cb63361d2755b77e9755d5feeb327b79ac7225b97ea721d1c4b.jpeg",
    ],
    sizes: [
      { id: "standard", label: "Standard", dim: '2.0″ x 3.5″', shape: "rect-h", multiplier: 1.0 },
      { id: "square", label: "Square", dim: '2.56″ x 2.56″', shape: "square", multiplier: 1.15 },
    ],
    finishes: [
      { id: "white", label: "Opaque White", desc: "Bright white PVC for high-contrast color. Prints on both sides.", oneSidedOnly: false },
      { id: "frosted", label: "Frosted", desc: "Smoky translucent finish for a premium feel. Printed on one side only.", oneSidedOnly: true },
      { id: "clear", label: "Clear", desc: "Fully transparent acrylic-like finish. Printed on one side only.", oneSidedOnly: true },
    ],
    corners: [
      { id: "rounded-quarter", label: 'Rounded 1/4"', desc: 'Generous 1/4" radius — soft, friendly, the standard plastic-card look.' },
      { id: "rounded-eighth", label: 'Rounded 1/8"', desc: 'Subtler 1/8" radius — barely rounded, closer to a clean square edge.' },
    ],
    quantityTiers: [
      { qty: 100, base: 169.99 },
      { qty: 250, base: 249.99 },
      { qty: 500, base: 299.99 },
      { qty: 1000, base: 399.99 },
    ],
    productionOptions: [
      {
        id: "regular",
        label: "Regular",
        days: "10–12 Business Days",
        multiplier: 1.0,
        desc: "Standard turnaround for Plastic cards. Plastic stock requires extra finishing time — ships within 10–12 business days of design approval.",
        icon: "Clock",
      },
    ],
    features: ["20pt waterproof plastic", "Opaque, frosted or clear", "Tear & scuff resistant", "Great for VIP / loyalty cards"],
    faqs: [
      {
        q: "What makes Plastic Business Cards different?",
        a: "These are printed on a durable 20pt Plastic (PVC) stock that's fully waterproof, tear-proof and scuff-resistant. They bend without breaking and shrug off rain, coffee and back-pocket abuse — perfect for membership, VIP, loyalty and ID-style cards.",
      },
      {
        q: "Which finish should I pick?",
        a: "Three finishes are available:\n• Opaque White — bright white PVC for high-contrast color. Prints on the front AND the back.\n• Frosted — smoky translucent stock with a premium feel. Printed on one side only.\n• Clear — fully transparent acrylic-like stock. Printed on one side only.",
      },
      {
        q: "Why are Frosted and Clear printed on one side only?",
        a: "Translucent and transparent stocks can't carry a second-side print without bleeding through and muddying the see-through aesthetic that makes those finishes special. If you need front and back printing, choose the Opaque White finish.",
      },
      {
        q: "What corner options are available?",
        a: 'All Plastic Business Cards ship with rounded corners — sharp square corners are not offered on this stock. Pick from:\n• Rounded 1/4" — generous radius, the classic plastic-card look.\n• Rounded 1/8" — subtler radius, closer to a clean square edge.',
      },
      {
        q: "What's the minimum order and what does it cost?",
        a: "Plastic Business Cards are available in 4 quantity tiers:\n• 100 cards — $169.99\n• 250 cards — $249.99\n• 500 cards — $299.99\n• 1,000 cards — $399.99\nNo other quantities are available for this product.",
      },
      {
        q: "How long until my cards arrive?",
        a: "Production takes 10–12 business days from design approval, plus shipping. Plastic stock requires extra cutting and finishing time, so Express production is not available on this product. If you need cards faster, our Regular Business Cards ship in 5–6 business days.",
      },
      {
        q: "Can your team design the cards for me?",
        a: "Yes. Pick the \"Let’s Print will design it for me\" option at checkout for a one-time $50 design fee. Our in-house team will craft a layout from your logo and brand notes, with two rounds of revisions included.",
      },
      {
        id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "We back our work with a strict Reprint Promise. If you contact us and send a photo within 5 days of delivery, we will happily reprint your order — no questions asked — if:\n• It's damaged: The items arrived bent, torn, or damaged in transit.\n• It's a production error: The final print does not match the artwork you approved or uploaded.\n\nNote: Our promise does not cover blurriness or low-quality issues resulting from low-resolution files provided or approved by the customer.",
      },
      {
        q: "What file format should I upload?",
        a: "Print-ready PDFs are best, but we also accept high-resolution PNG, JPG, AI and PSD files. Include 0.125\" bleed on all sides at 300 dpi. For Frosted and Clear finishes, keep critical text in solid dark colors — light tints can look washed out against translucent stock.",
      },
    ],
  },
  {
    slug: "raised-foil-business-cards",
    name: "Raised Foil Business Cards",
    category: "business-cards",
    type: "business-card",
    tagline: "A little shine goes a long way.",
    description:
      'Crafted on premium 16pt card stock with velvet lamination — 3.5" x 2" cards finished with genuine metallic foil stamped slightly above the surface.',
    longDescription:
      'Crafted on premium 16pt card stock with a luxurious velvet lamination, these standard 3.5" x 2" cards feature genuine metallic foil stamped slightly above the surface. Choose from gold, silver, or holographic foil—available on both sides. Whether applied to a logo, signature line, or intricate pattern, these striking, light-catching details are guaranteed to turn heads.',
    fromPrice: 189.99,
    minQty: 100,
    designFee: 65,
    image: "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/1d3ad323123b3930979b0887aca0c23e5a6b09e102ec452d3f408c2829bd1cfb.jpeg",
    images: [
      "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/1d3ad323123b3930979b0887aca0c23e5a6b09e102ec452d3f408c2829bd1cfb.jpeg",
      "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/ecb815b573a512160144b1e8b513d2c828e9dc5cef554cd09908adf2fb4453f6.jpeg",
      "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/e054b437d46418f3ae38b74633b061799b6f507fe874d50824d8dd3221a53fbe.jpeg",
    ],
    sizes: [
      { id: "standard", label: "Standard", dim: '3.5″ x 2″', shape: "rect-h", multiplier: 1.0 },
    ],
    finishes: [
      { id: "gold-foil", label: "Gold Foil", desc: "Warm, classic. The default for elegant branding." },
      { id: "silver-foil", label: "Silver Foil", desc: "Cool, modern, and reflectively striking." },
      { id: "holographic-foil", label: "Holographic", desc: "Iridescent rainbow shimmer that shifts with the light." },
    ],
    corners: [
      { id: "square", label: "Square", desc: "Sharp 90° corners. Crisp and confident." },
    ],
    quantityTiers: [
      { qty: 100, base: 189.99 },
      { qty: 250, base: 249.99 },
      { qty: 500, base: 349.99 },
    ],
    productionOptions: [
      {
        id: "regular",
        label: "Regular",
        days: "10–12 Business Days",
        multiplier: 1.0,
        desc: "Standard turnaround for Raised Foil cards. Foil stamping is hand-finished and requires extra production time — ships within 10–12 business days of design approval.",
        icon: "Clock",
      },
    ],
    features: ["Real raised metallic foil", "16pt premium stock", "Velvet lamination", "Gold, silver or holographic"],
    faqs: [
      {
        q: "What makes Raised Foil Business Cards different?",
        a: "These cards combine three premium effects: a 16pt card stock, a velvety soft-touch lamination, and genuine metallic foil that is stamped slightly above the surface of the card so you can both see and feel the shine. The raised tactile detail is what makes recipients keep them.",
      },
      {
        q: "Which foil colors are available?",
        a: "Three options:\n• Gold — warm, classic, the default for elegant branding.\n• Silver — cool, modern, reflectively striking.\n• Holographic — iridescent rainbow shimmer that shifts as it moves under the light.\nFoil can be applied to the front, the back, or both sides at no extra cost.",
      },
      {
        q: "Can I get foil on both sides?",
        a: 'Yes. Foil can be applied to the front, the back, or both sides of every card. Just upload separate artwork files for the front and back at checkout, and clearly mark which elements should be foiled.',
      },
      {
        q: "What size are the cards?",
        a: 'Raised Foil Business Cards are produced in the classic 3.5" x 2" standard horizontal size only. Other sizes are not available on this product because the foil stamping dies are calibrated for this format.',
      },
      {
        q: "Do you offer rounded corners on these cards?",
        a: "No — Raised Foil Business Cards are produced with sharp square 90° corners only. The velvet lamination and foil stamping process work best on a clean straight cut. If you'd like rounded corners, our Regular Business Cards support that option.",
      },
      {
        q: "What's the minimum order and what does it cost?",
        a: "Raised Foil Business Cards are available in 3 quantity tiers:\n• 100 cards — $189.99\n• 250 cards — $249.99\n• 500 cards — $349.99\nLarger quantities are not available for this product as each batch is hand-finished.",
      },
      {
        q: "How long until my cards arrive?",
        a: "Production takes 10–12 business days from design approval, plus shipping. Because foil is stamped one batch at a time, Express production is not available on this product. If you need cards faster, our Regular Business Cards ship in 5–6 business days.",
      },
      {
        q: "Can your team design the cards for me?",
        a: "Yes. Pick the \"Let’s Print will design it for me\" option at checkout for a one-time $65 design fee. Foil-ready files need a dedicated foil layer, and our in-house team will handle that prep along with two rounds of layout revisions.",
      },
      {
        id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "We back our work with a strict Reprint Promise. If you contact us and send a photo within 5 days of delivery, we will happily reprint your order — no questions asked — if:\n• It's damaged: The items arrived bent, torn, or damaged in transit.\n• It's a production error: The final print does not match the artwork you approved or uploaded.\n\nNote: Our promise does not cover blurriness or low-quality issues resulting from low-resolution files provided or approved by the customer.",
      },
      {
        q: "What file format should I upload?",
        a: `Print-ready PDFs are best. Include 0.125" bleed on all sides at 300 dpi, and provide a separate "Foil" spot color layer (100% magenta is fine) marking which elements should be foiled. We accept AI, PSD and PDF for foil work. If you only have a JPG/PNG, choose the Let’s Print design service so our team can prep the foil layer for you.`,
      },
    ],
  },
  {
    slug: "spot-uv-business-cards",
    name: "Spot UV Business Cards",
    category: "business-cards",
    type: "business-card",
    tagline: "A subtle shine where it counts.",
    description:
      'Standard 3.5" x 2" cards on heavy 16pt stock with velvety soft-touch finish and a thick, glossy raised Spot UV varnish on the elements you want to pop.',
    longDescription:
      'Crafted in a standard 3.5" x 2" size on a heavy 16pt card stock, these cards feature a luxurious, velvety soft-touch finish. By pairing this matte base with a thick, glossy raised varnish on specific design elements, your logos and accents will pop with a premium, tactile dimension that people can\'t stop running their fingers over.',
    fromPrice: 199.99,
    minQty: 100,
    designFee: 55,
    finishStepTitle: "Choose Raised Spot UV Side",
    image: "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/be35f9118726ec27cd1852e071590a585e1bc070036342d9cae817b7946fef71.jpeg",
    images: [
      "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/be35f9118726ec27cd1852e071590a585e1bc070036342d9cae817b7946fef71.jpeg",
      "https://static.prod-images.emergentagent.com/jobs/3c604512-8083-4d9c-b99e-a7248a4ddea2/images/f751847303e7aa6151e674ca07beda859911ee0804dfd1a3a598e4e1c132a62f.jpeg",
      "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/bf36y4de_SPOT%20UV%203.PNG",
    ],
    sizes: [
      { id: "standard", label: "Standard", dim: '3.5″ x 2″', shape: "rect-h", multiplier: 1.0 },
    ],
    finishes: [
      { id: "front-only", label: "Front Only", desc: "Raised Spot UV applied to the front of the card. Back is left in the soft-touch matte finish." },
      { id: "front-and-back", label: "Front and Back", desc: "Raised Spot UV applied to both the front and the back. Maximum tactile impact." },
    ],
    corners: [
      { id: "square", label: "Square", desc: "Sharp 90° corners. Crisp and confident." },
    ],
    quantityTiers: [
      { qty: 100, base: 199.99 },
      { qty: 250, base: 249.99 },
      { qty: 500, base: 299.99 },
      { qty: 1000, base: 349.99 },
    ],
    productionOptions: [
      {
        id: "regular",
        label: "Regular",
        days: "10–12 Business Days",
        multiplier: 1.0,
        desc: "Standard turnaround for Spot UV cards. The raised varnish is cured separately and requires extra finishing time — ships within 10–12 business days of design approval.",
        icon: "Clock",
      },
    ],
    features: ["Raised glossy Spot UV accents", "16pt soft-touch card stock", '3.5" x 2" standard size', "Made in the USA"],
    faqs: [
      {
        q: "What is a Raised Spot UV business card?",
        a: 'A Spot UV business card is built on a 16pt card stock with a soft-touch velvety matte coating. On top of that base, a thick clear varnish is applied to specific design elements (like your logo or tagline). The varnish dries slightly raised, so it both catches the light and is felt under the fingers when someone runs their thumb across the card.',
      },
      {
        q: "What size are the cards?",
        a: 'Spot UV Business Cards are produced in the classic 3.5" x 2" standard horizontal size only. Other sizes are not available because the Spot UV registration tooling is calibrated for this format.',
      },
      {
        q: "Can I get Spot UV on both sides?",
        a: "Yes — at the same price. Choose:\n• Front Only — raised varnish on the front of the card.\n• Front and Back — raised varnish on both the front AND the back for maximum tactile impact.\nThe full-color CMYK print underneath is always double-sided.",
      },
      {
        q: "Do you offer rounded corners on Spot UV cards?",
        a: "No — Spot UV Business Cards are produced with sharp square 90° corners only. The varnish registration process works best with a clean straight cut. If you'd like rounded corners, our Regular Business Cards support that option.",
      },
      {
        q: "What's the minimum order and what does it cost?",
        a: "Spot UV Business Cards are available in 4 quantity tiers:\n• 100 cards — $199.99\n• 250 cards — $249.99\n• 500 cards — $299.99\n• 1,000 cards — $349.99\nNo other quantities are available for this product.",
      },
      {
        q: "How long until my cards arrive?",
        a: "Production takes 10–12 business days from design approval, plus shipping. Because the Spot UV varnish layer is cured separately, Express production is not available on this product. If you need cards faster, our Regular Business Cards ship in 5–6 business days.",
      },
      {
        q: "Can your team design the cards for me?",
        a: `Yes. Pick the "Let’s Print will design it for me" option at checkout for a one-time $55 design fee. Our in-house team will set up a dedicated Spot UV layer for you (the varnish needs its own mask layer in the artwork) and include two rounds of revisions.`,
      },
      {
        id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "We back our work with a strict Reprint Promise. If you contact us and send a photo within 5 days of delivery, we will happily reprint your order — no questions asked — if:\n• It's damaged: The items arrived bent, torn, or damaged in transit.\n• It's a production error: The final print does not match the artwork you approved or uploaded.\n\nNote: Our promise does not cover blurriness or low-quality issues resulting from low-resolution files provided or approved by the customer.",
      },
      {
        q: "What file format should I upload?",
        a: `Print-ready PDFs are best. Include 0.125" bleed on all sides at 300 dpi, and provide a separate "SpotUV" spot color layer (100% magenta is fine) marking the elements you want raised and glossy. We accept AI, PSD and PDF for Spot UV work. If you only have a JPG/PNG, choose the Let’s Print design service so our team can prep the Spot UV layer for you.`,
      },
    ],
  },
  {
    slug: "flyers",
    name: "Flyers",
    category: "marketing-material",
    type: "flyer",
    tagline: "Hand-them-out marketing that actually gets noticed.",
    description:
      "Full-color flyers printed on heavy 16pt card stock paper. Matte or glossy finish. Five popular sizes. One-sided or two-sided printing — same price.",
    longDescription:
      'Our Flyers are printed on a heavy 16pt card stock that feels substantial in the hand — far above the flimsy 80lb sheets most printers use. Pick from five popular cuts (4"×6", 5"×7", 4"×9", 6.25"×9", or 8.5"×11"), choose a matte or glossy finish, and print front only or front-and-back for the same price.',
    fromPrice: 79.99,
    minQty: 100,
    designFee: 55,
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/flyers-hero.png`,
    images: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/flyers-hero.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/flyers.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/marketing-material.png`,
    ],
    sizes: [
      { id: "4x6", label: '4" x 6"', dim: '4" x 6"', shape: "rect-h", desc: "Postcard pocket-friendly handouts." },
      { id: "5x7", label: '5" x 7"', dim: '5" x 7"', shape: "rect-h", desc: "Bigger image area, still easy to mail." },
      { id: "4x9", label: '4" x 9"', dim: '4" x 9"', shape: "rect-h", desc: "Slim rack-card format. Fits a #10 envelope." },
      { id: "6.25x9", label: '6.25" x 9"', dim: '6.25" x 9"', shape: "rect-h", desc: "Oversized postcard — high visibility in the mail." },
      { id: "8.5x11", label: '8.5" x 11"', dim: '8.5" x 11"', shape: "rect-v", desc: "Full-page flyer. Maximum impact." },
    ],
    finishes: [
      { id: "matte", label: "Matte", desc: "Smooth shine-free finish. Looks premium and easy on the eyes." },
      { id: "gloss", label: "Glossy", desc: "Reflective sheen that makes photos and bold colors pop." },
    ],
    sidesOptions: [
      { id: "front", label: "Front Only", desc: "Print one side. Back is left blank.", uploads: 1 },
      { id: "front-back", label: "Front and Back", desc: "Full-color print on both sides — same price.", uploads: 2 },
    ],
    quantities: [100, 250, 500, 1000, 2500, 5000, 10000],
    priceMatrix: {
      "4x6":    { 100: 79.99,  250: 99.99,  500: 119.99, 1000: 129.99, 2500: 199.99, 5000: 249.99, 10000: 499.99 },
      "5x7":    { 100: 89.99,  250: 129.99, 500: 139.99, 1000: 149.99, 2500: 299.99, 5000: 399.99, 10000: 799.99 },
      "4x9":    { 100: 99.99,  250: 129.99, 500: 179.99, 1000: 199.99, 2500: 349.99, 5000: 499.99, 10000: 999.99 },
      "6.25x9": { 100: 99.99,  250: 179.99, 500: 249.99, 1000: 299.99, 2500: 399.99, 5000: 499.99, 10000: 999.99 },
      "8.5x11": { 100: 149.99, 250: 299.99, 500: 399.99, 1000: 449.99, 2500: 899.99, 5000: 1299.99, 10000: 2599.99 },
    },
    productionOptions: [
      { id: "regular", label: "Regular", days: "5–6 Business Days", multiplier: 1.0, desc: "Standard turnaround. Ships within 5–6 business days of design approval.", icon: "Clock" },
      { id: "express", label: "Express", days: "1–2 Business Days", multiplier: 1.25, desc: "Need it fast? Skip the line — your order ships within 1–2 business days for a 25% express fee.", icon: "Zap" },
    ],
    features: ["16pt card stock paper", "Matte or Glossy finish", "Front only or front + back (same price)", "Free local pickup at our Broward locations"],
    faqs: [
      {
        q: "What paper are flyers printed on?",
        a: "All of our flyers are printed on a heavy 16pt card stock — substantially thicker and stiffer than the 80lb or 100lb text-weight paper most quick-print shops use. The result is a flyer that feels premium in the hand and is far less likely to bend or smudge.",
      },
      {
        q: "Which sizes do you offer?",
        a: 'Five sizes are available:\n• 4" x 6" — postcard-friendly handouts\n• 5" x 7" — bigger image area, easy to mail\n• 4" x 9" — slim rack-card that fits a #10 envelope\n• 6.25" x 9" — oversized postcard, high mailbox visibility\n• 8.5" x 11" — full-page flyer, maximum impact\nNo custom sizes at this time.',
      },
      {
        q: "Matte or Glossy — which finish should I pick?",
        a: "Pick Matte if your flyer is text-heavy or you want a refined, low-glare look. Pick Glossy if your flyer is photo- or color-heavy — the sheen makes images pop. The paper stock, weight and pricing are identical for both finishes.",
      },
      {
        q: "Is two-sided printing the same price as one-sided?",
        a: "Yes — front-only and front-and-back printing are priced exactly the same. We won't charge you extra for using the back of the flyer. Just upload a second design file and we'll handle the rest.",
      },
      {
        q: "How does the pricing work?",
        a: "Pricing depends on size and quantity. The cheapest entry point is 100 flyers at 4\" x 6\" for $79.99; the largest is 10,000 flyers at 8.5\" x 11\" for $2,599.99. You'll see the live total on this page as you change size and quantity — no surprises at checkout.",
      },
      {
        q: "How long until my flyers arrive?",
        a: "Two options:\n• Regular — 5–6 business days from design approval, plus shipping.\n• Express — 1–2 business days, for a 25% rush fee added at checkout.\nLocal pickup at either of our Fort Lauderdale stores is free and available as soon as the order is finished.",
      },
      {
        q: "Can your team design the flyer for me?",
        a: `Yes. Pick the "Let’s Print will design it for me" option at checkout for a one-time $55 graphic design fee. Our in-house team will craft a layout based on your logo, photos and key copy, with two rounds of revisions included.`,
      },
      {
        q: "Do you offer free local pickup?",
        a: "Yes — local pickup is 100% free at both of our Fort Lauderdale locations (Broward Store at 3175 W Broward Blvd, and Swap Shop Store at 3291 W Sunrise Blvd). You'll get an email/text when your order is ready.",
      },
      {
        id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "We back our work with a strict Reprint Promise. If you contact us and send a photo within 5 days of delivery, we will happily reprint your order — no questions asked — if:\n• It's damaged: The items arrived bent, torn, or damaged in transit.\n• It's a production error: The final print does not match the artwork you approved or uploaded.\n\nNote: Our promise does not cover blurriness or low-quality issues resulting from low-resolution files provided or approved by the customer.",
      },
      {
        q: "What file format should I upload?",
        a: 'Print-ready PDFs are best, but we also accept high-resolution PNG, JPG, AI and PSD files. Include 0.125" bleed on all sides at 300 dpi, and keep critical text and logos at least 0.25" inside the trim line. If you upload front-and-back, label the files clearly (front.pdf / back.pdf) so we match them correctly.',
      },
    ],
  },
  {
    slug: "brochures",
    name: "Brochures",
    category: "marketing-material",
    type: "brochure",
    tagline: "Custom Brochures — big impact, small footprint.",
    description:
      "Vibrant, high-quality brochures printed on 100# Gloss Text paper. Two popular sizes, five professional folds, shipped pre-folded and ready to hand out.",
    longDescription:
      "Put your brand directly into your customers' hands with professional brochure printing from Let’s Print. Whether you need an eye-catching restaurant takeout menu or a sleek corporate sales tool, we deliver vibrant, high-quality prints that demand attention.\n\nWhy it works:\n• Tangible Marketing — better brand recall than digital ads\n• Budget-Friendly — low cost per unit, maximum ROI\n• Ready to Distribute — shipped pre-folded and box-ready\n\nPerfect for local businesses, restaurants, event organizers, realtors, agencies and nonprofits that want to make a lasting impression.",
    fromPrice: 199.99,
    minQty: 500,
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/brochures-hero.png`,
    images: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/brochures-hero.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/brochures-flat.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/marketing-material.png`,
    ],
    paperStock: "100# Gloss Text",
    sizes: [
      { id: "8.5x11", label: '8.5" × 11"', dim: '8.5" × 11"', shape: "rect-v", designFee: 55, desc: "Standard letter size — versatile and economical." },
      { id: "11x17", label: '11" × 17"', dim: '11" × 17"', shape: "rect-v", designFee: 75, desc: "Tabloid size — maximum space for content & visuals." },
    ],
    folds: [
      { id: "bi-fold",     label: "Bi-fold",            panels: 4, desc: "One center fold, four panels total. Clean and classic." },
      { id: "tri-fold",    label: "Tri-fold",           panels: 6, desc: "Two folds, six panels. The most popular brochure fold." },
      { id: "z-fold",      label: "Z-fold",             panels: 6, desc: "Two folds in a Z shape. Reveals panels in sequence as you unfold." },
      { id: "roll-fold",   label: "Roll Fold",          panels: 6, desc: "Three rolling folds. Reveals content progressively, panel by panel." },
      { id: "dbl-parallel", label: "Double Parallel Fold", panels: 8, desc: "Two parallel folds, eight panels. Lots of real estate for dense content." },
    ],
    quantities: [500, 1000, 2500, 5000, 10000],
    priceMatrix: {
      "8.5x11": { 500: 199.99, 1000: 229.99, 2500: 379.99, 5000: 483.99, 10000: 999.99 },
      "11x17":  { 500: 499.99, 1000: 549.99, 2500: 749.99, 5000: 1049.99, 10000: 1999.99 },
    },
    productionOptions: [
      { id: "regular", label: "Regular", days: "7–8 Business Days", multiplier: 1.0, desc: "Standard turnaround. Brochures are printed, folded and packed within 7–8 business days of design approval.", icon: "Clock" },
      { id: "express", label: "Express", days: "2–3 Business Days", multiplier: 1.25, desc: "Need it fast? Skip the line — your order ships within 2–3 business days for a 25% express fee.", icon: "Zap" },
    ],
    features: [
      "100# Gloss Text paper",
      "5 professional fold styles",
      "Shipped pre-folded & box-ready",
      "Free local pickup in South Florida",
    ],
    faqs: [
      {
        q: "What paper are brochures printed on?",
        a: "Every brochure is printed on premium 100# Gloss Text paper — substantial enough to feel professional in the hand while still folding crisply and laying flat. The gloss finish makes colors and photos pop and resists smudging during handling.",
      },
      {
        q: "What sizes do you offer?",
        a: 'Two popular brochure sizes:\n• 8.5" × 11" — standard letter size, versatile and economical, perfect for menus, sales flyers and event programs.\n• 11" × 17" — tabloid size, maximum space for content and visuals, ideal for full-color real estate guides, product catalogs and corporate sales sheets.',
      },
      {
        q: "Which fold style should I pick?",
        a: 'Five professional folds:\n• Bi-fold — one center fold, four panels. Clean and classic.\n• Tri-fold — two folds, six panels. The most popular brochure fold.\n• Z-fold — two folds in a Z shape, six panels. Reveals content in sequence.\n• Roll Fold — three rolling folds, six panels. Reveals content progressively, panel by panel.\n• Double Parallel Fold — two parallel folds, eight panels. Lots of real estate for dense content.\nNot sure which to pick? Tri-fold is the safe default for most use cases.',
      },
      {
        q: "How does the pricing work?",
        a: "Pricing depends on size and quantity:\n\n8.5\" × 11\":\n• 500 — $199.99\n• 1,000 — $229.99\n• 2,500 — $379.99\n• 5,000 — $483.99\n• 10,000 — $999.99\n\n11\" × 17\":\n• 500 — $499.99\n• 1,000 — $549.99\n• 2,500 — $749.99\n• 5,000 — $1,049.99\n• 10,000 — $1,999.99\n\nFolding is included at no extra charge — pick any of the five fold styles at the same price.",
      },
      {
        q: "What is the minimum order?",
        a: "500 brochures. Brochures are higher-touch to fold and pack than flyers, so we start production runs at 500 to keep per-unit pricing low for you. Need fewer than 500? Consider our Flyers product instead — they start at 100 units.",
      },
      {
        q: "How long until my brochures arrive?",
        a: "Two options:\n• Regular — 7–8 business days from design approval, plus shipping. Brochures take a little longer than flyers because they need to be printed, scored, folded and packed.\n• Express — 2–3 business days, for a 25% rush fee added at checkout.\nLocal pickup at either of our Fort Lauderdale stores is free and available as soon as the order is finished.",
      },
      {
        q: "Can your team design the brochure for me?",
        a: `Yes. Pick the "Let’s Print will design it for me" option at checkout. Design fees vary by size:\n• 8.5" × 11" — $55\n• 11" × 17" — $75\nOur in-house team will craft a fully panel-aware layout (factoring in your chosen fold style so content lands on the right panels), with two rounds of revisions included.`,
      },
      {
        q: "Do you ship the brochures pre-folded?",
        a: "Yes — every order is professionally scored and folded in-house, then packed flat in boxes ready to hand out. You don't need any tools, scoring boards or folding equipment when they arrive.",
      },
      {
        q: "Do you offer free local pickup?",
        a: "Yes — local pickup is 100% free at both of our Fort Lauderdale locations (Broward Store at 3175 W Broward Blvd, and Swap Shop Store at 3291 W Sunrise Blvd). You'll get an email/text when your order is ready.",
      },
      {
        id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "We back our work with a strict Reprint Promise. If you contact us and send a photo within 5 days of delivery, we will happily reprint your order — no questions asked — if:\n• It's damaged: The items arrived bent, torn, or damaged in transit.\n• It's a production error: The final print does not match the artwork you approved or uploaded.\n\nNote: Our promise does not cover blurriness or low-quality issues resulting from low-resolution files provided or approved by the customer.",
      },
      {
        q: "What file format should I upload?",
        a: `Print-ready PDFs are best. Set up your artwork at the full unfolded flat size (e.g. 8.5"×11" for a single-panel sheet, or 11"×8.5" landscape for an unfolded tri-fold) with 0.125" bleed on all sides at 300 dpi. Use fold-line guides so your content lands on the right panels — or skip the prep and let our Let’s Print team handle the panel layout for you.`,
      },
    ],
  },
  {
    slug: "eddm-postcards",
    name: "EDDM Postcards",
    category: "marketing-material",
    type: "eddm-postcard",
    tagline: "Local Marketing Made Simple with Let’s Print EDDM®.",
    description:
      "USPS-compliant Every Door Direct Mail® postcards in two oversized formats — pre-bundled in sets of 100 to make your post-office drop-off effortless.",
    longDescription:
      "Boosting your local reach has never been easier — or more affordable. Whether you run a restaurant, real estate agency, small business, or political campaign, our USPS-compliant Every Door Direct Mail (EDDM®) postcards deliver high-impact, oversized marketing straight to every mailbox on your target route.\n\nChoose from EDDM-approved sizes, printed on premium 16pt cardstock, with full-color front and back. To make your USPS drop-off completely hassle-free, we can pre-bundle your postcards in convenient sets of 100, and even print the USPS Retail EDDM Indicia directly on every card.",
    fromPrice: 79.99,
    minQty: 100,
    designFee: 55,
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/eddm-postcards-hero.png`,
    images: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/eddm-postcards-hero.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/eddm-postcards-flat.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/marketing-material.png`,
    ],
    sizes: [
      { id: "6.25x9", label: '6.25" x 9"', dim: '6.25" x 9"', shape: "rect-h", desc: "Oversized postcard — high mailbox visibility." },
      { id: "6.25x12", label: '6.25" x 12"', dim: '6.25" x 12"', shape: "rect-h", desc: "Maximum EDDM-approved size. Hard to miss." },
    ],
    finishes: [
      { id: "matte", label: "Matte", desc: "Smooth, shine-free finish. Great for text-heavy promos and writable surfaces." },
      { id: "gloss", label: "Glossy", desc: "Reflective sheen that makes photos and bold colors pop in the mailbox." },
    ],
    bundlingOptions: [
      {
        id: "no",
        label: "No Bundling",
        desc: "Postcards arrive shrink-wrapped in standard packs.",
      },
      {
        id: "yes",
        label: "Bundles of 100",
        desc: "Pre-bundled in USPS-ready sets of 100 — drop off and go.",
      },
    ],
    indiciaOptions: [
      {
        id: "no",
        label: "No Indicia",
        desc: "Print your own postage, hand-deliver, or add stamps yourself.",
      },
      {
        id: "yes",
        label: "Add Retail EDDM Indicia",
        desc: "USPS-compliant indicia printed on every card, ready for EDDM Retail drop-off.",
      },
    ],
    quantities: [100, 250, 500, 1000, 2500, 5000, 10000],
    priceMatrix: {
      "6.25x9": {
        100:   { base: 99.99,   bundling: 40,  indicia: 20  },
        250:   { base: 199.99,  bundling: 50,  indicia: 30  },
        500:   { base: 399.99,  bundling: 60,  indicia: 40  },
        1000:  { base: 429.99,  bundling: 70,  indicia: 50  },
        2500:  { base: 599.99,  bundling: 80,  indicia: 60  },
        5000:  { base: 999.99,  bundling: 90,  indicia: 80  },
        10000: { base: 1499.99, bundling: 120, indicia: 100 },
      },
      "6.25x12": {
        100:   { base: 79.99,  bundling: 40,  indicia: 20  },
        250:   { base: 159.99, bundling: 50,  indicia: 30  },
        500:   { base: 199.99, bundling: 60,  indicia: 40  },
        1000:  { base: 249.99, bundling: 70,  indicia: 50  },
        2500:  { base: 349.99, bundling: 80,  indicia: 60  },
        5000:  { base: 449.99, bundling: 90,  indicia: 80  },
        10000: { base: 999.99, bundling: 120, indicia: 100 },
      },
    },
    productionOptions: [
      { id: "regular", label: "Regular", days: "5–6 Business Days", multiplier: 1.0, desc: "Standard turnaround. Ships within 5–6 business days of design approval.", icon: "Clock" },
      { id: "express", label: "Express", days: "1–2 Business Days", multiplier: 1.25, desc: "Need it fast? Skip the line — your order ships within 1–2 business days for a 25% express fee.", icon: "Zap" },
    ],
    features: [
      "16pt premium cardstock",
      "USPS EDDM-approved sizes",
      "Optional bundles of 100",
      "Optional Retail EDDM Indicia",
    ],
    faqs: [
      {
        q: "What is EDDM® (Every Door Direct Mail)?",
        a: "EDDM® is a USPS service that lets businesses send oversized mail to every address on a chosen carrier route — no mailing list, no individual addressing, no stamps. You pay a flat retail rate per piece at the post office, and the carrier delivers your postcard to every mailbox on the route. It's the simplest and most affordable way to do a hyper-local marketing blast.",
      },
      {
        q: "Which sizes do you offer for EDDM?",
        a: 'Two EDDM-approved sizes:\n• 6.25" x 9" — oversized postcard, high mailbox visibility.\n• 6.25" x 12" — the maximum EDDM-approved size. Hard to miss in any mailbox.',
      },
      {
        q: "What paper are EDDM postcards printed on?",
        a: "Every EDDM postcard is printed on a premium 16pt cardstock with full-color front and back. The 16pt weight is rigid enough to survive USPS handling without bending, scuffing or curling.",
      },
      {
        q: "Matte or Glossy — which finish should I pick?",
        a: "Pick Matte if your design is text-heavy, you want a refined low-glare look, or you want recipients to write notes on the card. Pick Glossy if your design is photo- or color-heavy — the sheen makes images pop. Both finishes are priced exactly the same.",
      },
      {
        q: "What is the Bundles of 100 option?",
        a: "USPS requires EDDM postcards to be dropped off in bundles of 100 with a slip of paper labeled with route and quantity info. If you pick Bundles of 100, we'll do all of that for you — your postcards arrive pre-bundled, banded, and labeled, ready to be handed across the post office counter. The add-on price ranges from $40 (100 cards) to $120 (10,000 cards) and is shown live as you change the quantity.",
      },
      {
        q: "What is the Retail EDDM Indicia option?",
        a: "EDDM Retail Indicia is the USPS-compliant postage mark that needs to appear on every EDDM postcard. If you pick \"Add Retail EDDM Indicia\", we'll print the USPS-approved mark directly on every card, so you don't need to add stamps or postage at drop-off. The add-on price ranges from $20 (100 cards) to $100 (10,000 cards). If you skip the indicia, you'll need to print your own postage or arrange separate delivery.",
      },
      {
        q: "How does the pricing work?",
        a: "Base price depends on size and quantity. Bundling and Indicia are optional add-ons priced separately. The page shows your live total in the right-hand summary panel — you'll always see exactly what each add-on costs before checkout.",
      },
      {
        q: "How long until my postcards arrive?",
        a: "Two options:\n• Regular — 5–6 business days from design approval, plus shipping.\n• Express — 1–2 business days, for a 25% rush fee added at checkout.\nLocal pickup at either of our Fort Lauderdale stores is free and available as soon as the order is finished.",
      },
      {
        q: "Can your team design the postcard for me?",
        a: `Yes. Pick the "Let’s Print will design it for me" option at checkout for a one-time $55 graphic design fee. Our in-house team will craft a USPS-compliant EDDM layout (with the required indicia placement and address block clear zones) based on your logo, photos and key copy, with two rounds of revisions included.`,
      },
      {
        q: "Do you offer free local pickup?",
        a: "Yes — local pickup is 100% free at both of our Fort Lauderdale locations (Broward Store at 3175 W Broward Blvd, and Swap Shop Store at 3291 W Sunrise Blvd). You'll get an email/text when your order is ready.",
      },
      {
        id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "We back our work with a strict Reprint Promise. If you contact us and send a photo within 5 days of delivery, we will happily reprint your order — no questions asked — if:\n• It's damaged: The items arrived bent, torn, or damaged in transit.\n• It's a production error: The final print does not match the artwork you approved or uploaded.\n\nNote: Our promise does not cover blurriness or low-quality issues resulting from low-resolution files provided or approved by the customer.",
      },
      {
        q: "What file format should I upload?",
        a: `Print-ready PDFs are best, but we also accept high-resolution PNG, JPG, AI and PSD files. Include 0.125" bleed on all sides at 300 dpi. EDDM postcards must follow USPS layout rules: keep a clear address area on the back (4.625" x 2" minimum) and a clear indicia area in the top-right corner. If that sounds complicated, just choose our Let’s Print design service and we will set up a fully USPS-compliant layout for you.`,
      },
    ],
  },
  {
    slug: "car-magnets",
    name: "Car Magnets",
    category: "marketing-material",
    type: "car-magnet",
    tagline: "Affordable mobile advertising — turn your car into a billboard.",
    description:
      "Maximize brand visibility everywhere you drive. Premium 30 mil UV-protected car magnets — non-permanent, weather-resistant, and reusable.",
    longDescription:
      "Custom Car Magnets — Affordable Mobile Advertising. Transform your vehicle into a powerful marketing tool with custom Car Magnets from Let’s Print. Ideal for small businesses, contractors, delivery services, and real estate agents, our car magnets provide an affordable, removable, and non-damaging alternative to permanent vehicle graphics.\n\nPrinted on 30 mil premium magnet stock with a UV-protected coating for durability in all climates. Choose from three popular sizes or enter a fully custom width × height — perfect for car doors, trucks, and vans.\n\nNote: Car magnets work best on smooth, flat, steel surfaces. Not compatible with fiberglass or curved panels. Try sticking a fridge magnet to your vehicle — if it holds, ours will too.",
    fromPrice: 70,
    designFee: 35,
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/car-magnets-hero.png`,
    images: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/car-magnets-hero.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/car-magnets-flat.png`,
    ],
    material: "30 mil UV-protected car magnet",
    pricePerSqFt: 22.44,
    minWidth: 5,
    maxWidth: 48,
    minHeight: 5,
    maxHeight: 24,
    minQuantity: 1,
    maxQuantity: 20,
    sizes: [
      { id: "12x18", label: '12" × 18"', w: 12, h: 18, desc: "Compact — fits most sedan car doors." },
      { id: "14x24", label: '14" × 24"', w: 14, h: 24, desc: "Mid-size — great for SUVs & vans." },
      { id: "18x24", label: '18" × 24"', w: 18, h: 24, desc: "Large — maximum visibility on trucks." },
      { id: "custom", label: "Custom", w: null, h: null, desc: "Enter your own dimensions." },
    ],
    productionOptions: [
      { id: "regular", label: "Regular", days: "5–6 Business Days", multiplier: 1.0, desc: "Standard turnaround. Ships within 5–6 business days of design approval.", icon: "Clock" },
      { id: "express", label: "Express", days: "1–2 Business Days", multiplier: 1.25, desc: "Need it fast? Skip the line — your order ships within 1–2 business days for a 25% express fee.", icon: "Zap" },
    ],
    features: [
      "30 mil UV-protected car magnet",
      "Non-permanent, no damage to your car",
      "Weather-resistant for all climates",
      "Free local pickup in South Florida",
    ],
    faqs: [
      {
        q: "What are the car magnets made of?",
        a: "Every car magnet is printed on a 30 mil premium magnet stock with a UV-protected glossy coating. The 30 mil thickness is rigid enough to hold its shape at highway speed, while the UV coating keeps the print vibrant for years through rain, sun and heat.",
      },
      {
        q: "Will the magnets damage my car?",
        a: "No. Our car magnets are completely non-permanent. They apply by hand, hold firm with magnetic force only, and peel off cleanly any time you want to remove them or wash your vehicle. They will not damage paint, clear coat or trim.",
      },
      {
        q: "Will the magnets stick to my vehicle?",
        a: "Car magnets only adhere to smooth, flat, steel-bodied panels. They will not stick to fiberglass, aluminium, plastic or strongly curved panels. The simplest test: stick an ordinary refrigerator magnet to the area you're considering. If the fridge magnet holds firm, ours will too. If it slides off, the panel isn't compatible.",
      },
      {
        q: "How many magnets can I order?",
        a: "Any quantity from 1 to 20 magnets per order. Most cars need a pair (one for each door), but order whatever fits your vehicle and your campaign. If you need more than 20 magnets in a single order, contact us and we'll set up a custom bulk quote.",
      },
      {
        q: "How is the price calculated?",
        a: 'Pricing is a single simple formula based on the magnet area in square feet:\n\n   (Width × Height) ÷ 144 × $22.44 = price per magnet\n\nYour total = price per magnet × quantity. The same formula applies whether you pick one of our standard sizes or enter your own custom dimensions, so what you see on the page is always exactly what you pay.\n\nExample: a 20" × 10" magnet → (20 × 10) ÷ 144 = 1.39 sq ft → 1.39 × $22.44 ≈ $31.17 per magnet. Two of them would be $62.34.',
      },
      {
        q: "What sizes do you offer?",
        a: 'Three popular standard sizes:\n• 12" × 18" — compact, fits most sedan car doors\n• 14" × 24" — mid-size, great for SUVs and vans\n• 18" × 24" — large, maximum visibility on trucks\nIf none of these fit your vehicle, choose the Custom option and enter any dimensions between 5" – 48" wide and 5" – 24" tall.',
      },
      {
        q: "Can the magnets be printed on both sides?",
        a: "No — car magnets are printed on the front side only. The back is the raw magnet surface that grips your vehicle. If you need different artwork for the left and right side of your car, simply order the magnets as two separate single-side designs.",
      },
      {
        q: "How long until my magnets arrive?",
        a: "Two options:\n• Regular — 5–6 business days from design approval, plus shipping.\n• Express — 1–2 business days, for a 25% rush fee added at checkout.\nLocal pickup at either of our Fort Lauderdale stores is free and available as soon as the order is finished.",
      },
      {
        q: "Can your team design the magnets for me?",
        a: `Yes. Pick the "Let’s Print will design it for me" option at checkout for a one-time $35 graphic design fee. Our in-house team will craft a layout based on your logo, photos, phone number and key copy, with two rounds of revisions included.`,
      },
      {
        q: "Do you offer free local pickup?",
        a: "Yes — local pickup is 100% free at both of our Fort Lauderdale locations (Broward Store at 3175 W Broward Blvd, and Swap Shop Store at 3291 W Sunrise Blvd). You'll get an email/text when your order is ready.",
      },
      {
        id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "We back our work with a strict Reprint Promise. If you contact us and send a photo within 5 days of delivery, we will happily reprint your order — no questions asked — if:\n• It's damaged: The items arrived bent, torn, or damaged in transit.\n• It's a production error: The final print does not match the artwork you approved or uploaded.\n\nNote: Our promise does not cover blurriness or low-quality issues resulting from low-resolution files provided or approved by the customer.",
      },
      {
        q: "What file format should I upload?",
        a: 'Print-ready PDFs are best, but we also accept high-resolution PNG, JPG, AI and PSD files. Include 0.25" bleed on all sides at 150 dpi at final print size, and keep critical text, logos and phone numbers at least 0.5" inside the trim line so they\'re comfortable to read from a moving vehicle.',
      },
    ],
  },
  {
    slug: "retractable-banner",
    name: "Retractable Banner",
    category: "marketing-material",
    type: "retractable-banner",
    tagline: "Command the room at your next event.",
    description:
      "Premium retractable roll-up banners with zero-tool setup. Standard 33\" × 80\", printed on scuff-resistant 10 mil indoor vinyl, shipped preassembled in a durable carrying case. Made in the USA.",
    longDescription:
      "Stop competing for attention — demand it. Whether you're setting up at a bustling trade show, a local farmers market, or updating your storefront, our retractable banners ensure your brand is the main attraction.\n\nEngineered for maximum visibility and zero stress, they arrive preassembled and ready to work. Just pull up, lock in place, and watch the crowds gather.\n\nWhy you'll love it:\n• Zero-tool, 30-second setup — just roll it up to display and roll it down to pack away.\n• Ready to travel — every banner comes preassembled in its hardware and includes a durable, lightweight carrying case.\n• Built to last — printed on premium, scuff-resistant material designed to look crisp and vibrant event after event.\n\nIdeal for: Trade Shows · Expos · Conventions · Retail Storefronts · Pop-Up Shops · Farmers Markets · Craft Fairs · Conferences · Workshops · Product Launches · Interactive QR Code Displays.",
    fromPrice: 160,
    minQty: 1,
    designFee: 55,
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/retractable-banner-hero.png`,
    images: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/retractable-banner-hero.png`,
      "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/30wrpnn7_image.png",
      "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/yxzboa85_image.png",
      "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/n7lan0vo_image.png",
    ],
    bannerSize: '33" × 80"',
    material: "10 mil indoor vinyl",
    minQuantity: 1,
    maxQuantity: 50,
    stands: [
      {
        id: "regular",
        label: "Regular",
        price: 160,
        desc: "Silver aluminum base. The classic crowd-pleaser at every event.",
        image: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/30wrpnn7_image.png",
      },
      {
        id: "black",
        label: "Regular Black",
        price: 185,
        desc: "Sleek matte-black base. Modern look that stands out at darker venues.",
        image: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/n7lan0vo_image.png",
      },
      {
        id: "deluxe",
        label: "Deluxe",
        price: 250,
        desc: "Premium chrome base with reinforced retraction. Smoother roll-up, longer service life.",
        image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/retractable-deluxe-clean.png`,
        badge: "Premium",
      },
      {
        id: "black-nfc",
        label: "Black + NFC",
        price: 250,
        desc: "Matte-black base with a built-in NFC tag — tap-to-launch your website, menu or product page.",
        image: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/n7lan0vo_image.png",
        badge: "Smart",
        hasNfc: true,
      },
    ],
    discountTiers: [
      { minQty: 1, percent: 0,  label: "1" },
      { minQty: 2, percent: 2,  label: "2–3" },
      { minQty: 4, percent: 4,  label: "4–5" },
      { minQty: 6, percent: 6,  label: "6–7" },
      { minQty: 8, percent: 8,  label: "8–9" },
      { minQty: 10, percent: 10, label: "10+" },
    ],
    productionOptions: [
      { id: "regular", label: "Regular", days: "5–6 Business Days", multiplier: 1.0, desc: "Standard turnaround. Ships within 5–6 business days of design approval.", icon: "Clock" },
      { id: "express", label: "Express", days: "1–2 Business Days", multiplier: 1.25, desc: "Need it fast? Skip the line — your order ships within 1–2 business days for a 25% express fee.", icon: "Zap" },
    ],
    features: [
      "33\" × 80\" — standard event size",
      "10 mil scuff-resistant indoor vinyl",
      "Zero-tool 30-second setup",
      "Carrying case included",
    ],
    faqs: [
      {
        q: "What's included in the box?",
        a: "Every order ships preassembled and ready to use. You get:\n• The printed 33\" × 80\" banner already attached to the retractable stand\n• A durable, lightweight carrying case with a shoulder strap\n• A pop-up support pole and base\n\nNo tools or assembly required — pull the pole up, hook it into the top rail, and you're done in under 30 seconds.",
      },
      {
        q: "What size is the banner?",
        a: "Every retractable banner is the standard event size of 33\" × 80\" (roughly 84 cm × 203 cm). This is the size most trade-show booths, conference foyers and pop-up displays are designed around.",
      },
      {
        q: "What is the banner printed on?",
        a: "We print on premium 10 mil indoor vinyl with a scuff-resistant matte laminate. The 10 mil weight is heavy enough to hang flat without curling at the edges, and the laminate keeps colors looking vibrant event after event — even with regular roll-up / roll-down handling.",
      },
      {
        q: "Which stand should I choose?",
        a: "Four stand options, same banner:\n• Regular — silver aluminum base, the classic crowd-pleaser ($160).\n• Regular Black — sleek matte-black base, great for darker venues ($185).\n• Deluxe — premium chrome base with reinforced retraction; smoother roll-up and longer service life ($250).\n• Black + NFC — matte-black base with a built-in NFC tag visitors can tap with their phone to instantly open your website, menu or product page ($250).",
      },
      {
        q: "How does the NFC option work?",
        a: 'The Black + NFC stand has a small NFC tag embedded in the bottom rail of the banner. We program it with the URL of your choice (your website, a Google Maps location, a menu PDF, a YouTube video — anything that opens in a browser). When a visitor taps their phone against the NFC zone, the URL opens automatically. No app or special setup required. You can reprogram the tag any time using the free "NFC Tools" app available for iOS and Android.',
      },
      {
        q: "Can I order multiple banners?",
        a: "Yes. You can order from 1 to 50 banners per order, with automatic quantity discounts:\n• 1 banner — no discount\n• 2–3 banners — 2% off\n• 4–5 banners — 4% off\n• 6–7 banners — 6% off\n• 8–9 banners — 8% off\n• 10+ banners — 10% off\nDiscount applies to the banner subtotal automatically. Need more than 50? Contact us for a custom bulk quote.",
      },
      {
        q: "How long until my banner arrives?",
        a: "Two options:\n• Regular — 5–6 business days from design approval, plus shipping.\n• Express — 1–2 business days, for a 25% rush fee added at checkout.\nLocal pickup at either of our Fort Lauderdale stores is free and available as soon as the order is finished.",
      },
      {
        q: "Can your team design the banner for me?",
        a: `Yes. Pick the "Let’s Print will design it for me" option at checkout for a one-time $55 graphic design fee. Our in-house team will craft a layout based on your logo, photos and key copy, with two rounds of revisions included. We design specifically for the 33" × 80" portrait format with proper text-sizing so it reads from across a busy room.`,
      },
      {
        q: "Do you offer free local pickup?",
        a: "Yes — local pickup is 100% free at both of our Fort Lauderdale locations (Broward Store at 3175 W Broward Blvd, and Swap Shop Store at 3291 W Sunrise Blvd). You'll get an email/text when your order is ready.",
      },
      {
        id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "We back our work with a strict Reprint Promise. If you contact us and send a photo within 5 days of delivery, we will happily reprint your order — no questions asked — if:\n• It's damaged: The items arrived bent, torn, or damaged in transit.\n• It's a production error: The final print does not match the artwork you approved or uploaded.\n\nNote: Our promise does not cover blurriness or low-quality issues resulting from low-resolution files provided or approved by the customer.",
      },
      {
        q: "What file format should I upload?",
        a: `Print-ready PDFs are best. Set up your artwork at the full banner size (33" × 80") with 0.5" bleed all around at 150 dpi. Keep critical text and logos in the top 60% of the banner so they stay above eye level. Avoid placing important elements in the bottom 4" — that part sits inside the stand base and is not visible. If you need help, choose our Let’s Print design service.`,
      },
    ],
  },
  {
    slug: "outdoor-banner",
    name: "Outdoor Banner",
    category: "signs-banners-poster",
    type: "vinyl-banner",
    tagline: "Command attention with custom vinyl banners.",
    description:
      "Heavy-duty 13oz matte vinyl banners built for the outdoors. Fade-, tear-, and weather-resistant. Custom sizes from 1 ft up to 10 × 150 ft.",
    longDescription:
      "From local storefront promotions to massive stadium backdrops, Let’s Print delivers heavy-duty, full-color vinyl banners built to get you noticed. Engineered to withstand the elements, our banners are fade-resistant, tear-resistant, and perfect for both indoor and outdoor use.\n\nGo big — up to 150 feet! With our advanced wide-format printing, we can handle projects of almost any scale:\n• Widths: 1 ft to 10 ft\n• Lengths: up to 150 ft\n• Need something even larger? Contact us for a custom oversized estimate.\n\nThe Let’s Print Advantage:\n• Vivid full-color printing — crisp, eye-catching graphics that make your brand pop.\n• Built for the elements — weather-resistant materials that fight off sun, wind, and rain.\n• Premium finishing — choose from ropes, pole pockets, or clear, rust-free grommets for a sleek, professional hang.\n• Optional lamination — add a matte or gloss finish to extend your banner's lifespan up to 12 months.\n• Fast turnaround — same-day and next-day service available.\n• Versatile signage for every occasion — grand openings, construction sites, real estate listings, trade shows, and community festivals.",
    fromPrice: 13.5,
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/outdoor-banner-hero.png`,
    images: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/outdoor-banner-hero.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/retractable-banner-hero.png`,
    ],
    material: "13oz Matte Vinyl Banner",
    pricePerSqFtSmall: 4.5,
    pricePerSqFtLarge: 3.5,
    largeThresholdInches: 60,
    designFeeSmall: 55,
    designFeeLarge: 75,
    sizes: [
      { id: "24x36", label: '24" × 36"', w: 24, h: 36, desc: "Compact storefront sign." },
      { id: "24x48", label: '24" × 48"', w: 24, h: 48, desc: "Standard 2 × 4 ft format." },
      { id: "36x36", label: '36" × 36"', w: 36, h: 36, desc: "Square 3 × 3 ft." },
      { id: "36x48", label: '36" × 48"', w: 36, h: 48, desc: "Popular event size." },
      { id: "48x60", label: '48" × 60"', w: 48, h: 60, desc: "Large 4 × 5 ft." },
      { id: "48x72", label: '48" × 72"', w: 48, h: 72, desc: "Grand-opening / construction." },
      { id: "84x84", label: '84" × 84"', w: 84, h: 84, desc: "Massive square — backdrop scale." },
      { id: "96x96", label: '96" × 96"', w: 96, h: 96, desc: "Full 8 × 8 ft." },
      { id: "96x120", label: '96" × 120"', w: 96, h: 120, desc: "Stadium-scale impact." },
      { id: "custom", label: "Custom", w: null, h: null, desc: "Up to 10 × 150 ft." },
    ],
    minWidthIn: 12,
    maxWidthIn: 120,
    minHeightIn: 12,
    maxHeightIn: 1800,
    minQuantity: 1,
    maxQuantity: 50,
    hemPrice: 10,
    polePocketPrice: 10,
    grommetPricePerEach: 2,
    grommetOptions: [
      { id: "none",      label: "No grommets",      desc: "No grommets installed. Best for indoor displays where the banner is taped, framed, or hung without ropes.", spacingIn: null },
      { id: "corner",    label: "Corner only",      desc: "4 grommets (one in each corner). Cheapest hang option.", spacingIn: null },
      { id: "every-2ft", label: "Every 2 ft",       desc: "Grommets along all edges, 24 inches apart.", spacingIn: 24 },
      { id: "every-18in",label: "Every 18 in",      desc: "Tighter spacing for added support.",        spacingIn: 18 },
      { id: "every-1ft", label: "Every 1 ft",       desc: "Heaviest hang strength. Recommended for large banners.", spacingIn: 12 },
    ],
    productionOptions: [
      { id: "regular", label: "Regular", days: "5–6 Business Days", multiplier: 1.0, desc: "Standard turnaround. Ships within 5–6 business days of design approval.", icon: "Clock" },
      { id: "express", label: "Express", days: "1–2 Business Days", multiplier: 1.25, desc: "Need it fast? Ships within 1–2 business days for a 25% express fee.", icon: "Zap" },
    ],
    features: [
      "13oz matte vinyl — outdoor-rated",
      "Fade, tear & weather resistant",
      "Up to 10 × 150 ft",
      "Free local pickup in South Florida",
    ],
    faqs: [
      { q: "What is the banner made of?",
        a: "Outdoor banners are printed on heavy-duty 13oz matte vinyl. The 13oz weight is rated for outdoor use — UV-resistant inks fight fading, the matte finish kills glare in direct sun, and the vinyl is tear-resistant in wind. With optional hems and properly spaced grommets, our banners routinely last 6–12 months outdoors and even longer indoors." },
      { q: "What sizes can I order?",
        a: "Widths from 1 ft to 10 ft, lengths up to 150 ft. Pick one of our standard sizes or choose Custom and enter any dimensions within those limits. Need something even larger? Contact us for a custom oversized estimate." },
      { q: "How is the price calculated?",
        a: "Pricing is by area, with a discount on larger banners:\n\n   (Width × Height in inches) ÷ 144 × rate per sq ft\n\nRates:\n• Banners 5 ft or under on both dimensions — $4.50 / sq ft\n• Banners over 5 ft on either dimension — $3.50 / sq ft (the large-format rate)\n\nExample: a 3 ft × 6 ft banner → 36 × 72 ÷ 144 = 18 sq ft → 18 × $4.50 = $81.00. The page shows the live price as you select size or type custom dimensions." },
      { q: "What is hemming and should I add it?",
        a: "Hemming is when we fold one inch of the vinyl material over to the backside of the banner and heat-seal it to form a clean, strong 1\" hem. The hem reinforces the edge so grommets don't tear out, especially on larger banners. Hems are highly recommended — adding them costs just $10 per banner. Ordering without hems on a large banner runs the risk of the grommets tearing out of the material in wind." },
      { q: "What are grommets and which spacing should I pick?",
        a: 'Grommets are metal rings inserted into holes through the vinyl, collared on each side to keep them held securely in place. They prevent tearing or abrasion of the material when ropes, bungee cords or zip ties are routed through the holes.\n\nFour spacing options at $2 per grommet:\n• Corner only — 4 grommets, cheapest, fine for very small banners.\n• Every 2 ft — standard for most banners.\n• Every 18 in — tighter spacing for added support.\n• Every 1 ft — heaviest hang strength, recommended for the largest banners and high-wind locations.\n\nThe page calculates and shows the exact grommet count for your chosen size and spacing in real time.' },
      { q: "What is a pole pocket?",
        a: "A pole pocket is a sewn 4\" sleeve along the top and bottom of the banner (no grommets needed in those edges) that lets you slide a horizontal pole, dowel or pipe straight through for hanging. It gives the banner a cleaner, more retail-store look. Pole pockets are an optional add-on for $10 per banner." },
      { q: "How long until my banner arrives?",
        a: "• Regular — 5–6 business days from design approval.\n• Express — 1–2 business days for a 25% rush fee.\nLocal pickup at either Fort Lauderdale store is free as soon as the order is finished." },
      { q: "Can your team design the banner for me?",
        a: `Pick the "Let’s Print will design it for me" option at checkout. Design fees vary with size:\n• Banners up to 5 ft — $55\n• Banners over 5 ft — $75\nOur in-house team handles the full layout (logo, photos, headline copy) with proper bleed and large-format typography so it reads from across a parking lot. 2 rounds of revisions included.` },
      { q: "Do you offer free local pickup?",
        a: "Yes — 100% free at both Fort Lauderdale stores (Broward Store at 3175 W Broward Blvd; Swap Shop Store at 3291 W Sunrise Blvd). You'll get an email/text when your order is ready." },
      { id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "We back our work with a strict Reprint Promise. If you contact us and send a photo within 5 days of delivery, we will happily reprint your order — no questions asked — if:\n• It's damaged: The items arrived bent, torn, or damaged in transit.\n• It's a production error: The final print does not match the artwork you approved or uploaded.\n\nNote: Our promise does not cover blurriness or low-quality issues resulting from low-resolution files provided or approved by the customer." },
      { q: "What file format should I upload?",
        a: 'Print-ready PDFs are best at full final banner size. We accept PDF, AI, PSD, PNG and JPG. Build artwork at 150 dpi (large banners) or 300 dpi (small banners) with 0.5" bleed on all sides. Keep important text and logos at least 2" inside the trim line — that area can be eaten into by hems or grommets. If files are huge, contact us for an upload link.' },
    ],
  },
  {
    slug: "indoor-banner",
    name: "Indoor Banner",
    category: "signs-banners-poster",
    type: "vinyl-banner",
    tagline: "Command attention with custom vinyl banners.",
    description:
      "Smooth 10 mil indoor vinyl banners with a clean satin look. Custom sizes from 1 ft up to 10 × 150 ft. Perfect for trade shows, lobbies and pop-ups.",
    longDescription:
      "From local storefront promotions to massive stadium backdrops, Let’s Print delivers heavy-duty, full-color vinyl banners built to get you noticed. Engineered to withstand the elements, our banners are fade-resistant, tear-resistant, and perfect for both indoor and outdoor use.\n\nGo big — up to 150 feet! With our advanced wide-format printing, we can handle projects of almost any scale:\n• Widths: 1 ft to 10 ft\n• Lengths: up to 150 ft\n• Need something even larger? Contact us for a custom oversized estimate.\n\nThe Let’s Print Advantage:\n• Vivid full-color printing — crisp, eye-catching graphics that make your brand pop.\n• Built for the elements — weather-resistant materials that fight off sun, wind, and rain.\n• Premium finishing — choose from ropes, pole pockets, or clear, rust-free grommets for a sleek, professional hang.\n• Optional lamination — add a matte or gloss finish to extend your banner's lifespan up to 12 months.\n• Fast turnaround — same-day and next-day service available.\n• Versatile signage for every occasion — grand openings, construction sites, real estate listings, trade shows, and community festivals.",
    fromPrice: 16.5,
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/indoor-banner-hero.png`,
    images: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/indoor-banner-hero.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/retractable-banner-hero.png`,
    ],
    material: "10 Mil Indoor Vinyl Banner",
    pricePerSqFtSmall: 5.5,
    pricePerSqFtLarge: 4.5,
    largeThresholdInches: 60,
    designFeeSmall: 55,
    designFeeLarge: 75,
    sizes: [
      { id: "33x80", label: '33" × 80"', w: 33, h: 80, desc: "Retractable-banner format." },
      { id: "24x48", label: '24" × 48"', w: 24, h: 48, desc: "Compact 2 × 4 ft." },
      { id: "24x60", label: '24" × 60"', w: 24, h: 60, desc: "Tall narrow 2 × 5 ft." },
      { id: "24x72", label: '24" × 72"', w: 24, h: 72, desc: "Slim 2 × 6 ft banner." },
      { id: "36x36", label: '36" × 36"', w: 36, h: 36, desc: "Square 3 × 3 ft." },
      { id: "36x48", label: '36" × 48"', w: 36, h: 48, desc: "Most popular trade-show size." },
      { id: "36x60", label: '36" × 60"', w: 36, h: 60, desc: "Vertical 3 × 5 ft." },
      { id: "36x72", label: '36" × 72"', w: 36, h: 72, desc: "Tall 3 × 6 ft." },
      { id: "48x48", label: '48" × 48"', w: 48, h: 48, desc: "Square 4 × 4 ft." },
      { id: "48x60", label: '48" × 60"', w: 48, h: 60, desc: "Medium 4 × 5 ft." },
      { id: "48x72", label: '48" × 72"', w: 48, h: 72, desc: "Lobby & step-and-repeat." },
      { id: "84x84", label: '84" × 84"', w: 84, h: 84, desc: "Massive 7 × 7 ft square." },
      { id: "96x96", label: '96" × 96"', w: 96, h: 96, desc: "Full 8 × 8 ft." },
      { id: "96x120", label: '96" × 120"', w: 96, h: 120, desc: "Full backdrop coverage." },
      { id: "custom", label: "Custom", w: null, h: null, desc: "Up to 10 × 150 ft." },
    ],
    minWidthIn: 12,
    maxWidthIn: 120,
    minHeightIn: 12,
    maxHeightIn: 1800,
    minQuantity: 1,
    maxQuantity: 50,
    hemPrice: 10,
    polePocketPrice: 10,
    grommetPricePerEach: 2,
    grommetOptions: [
      { id: "none",      label: "No grommets",      desc: "No grommets installed. Best for indoor displays where the banner is taped, framed, or hung without ropes.", spacingIn: null },
      { id: "corner",    label: "Corner only",      desc: "4 grommets (one in each corner). Cheapest hang option.", spacingIn: null },
      { id: "every-2ft", label: "Every 2 ft",       desc: "Grommets along all edges, 24 inches apart.", spacingIn: 24 },
      { id: "every-18in",label: "Every 18 in",      desc: "Tighter spacing for added support.",        spacingIn: 18 },
      { id: "every-1ft", label: "Every 1 ft",       desc: "Heaviest hang strength. Recommended for large banners.", spacingIn: 12 },
    ],
    productionOptions: [
      { id: "regular", label: "Regular", days: "5–6 Business Days", multiplier: 1.0, desc: "Standard turnaround. Ships within 5–6 business days of design approval.", icon: "Clock" },
      { id: "express", label: "Express", days: "1–2 Business Days", multiplier: 1.25, desc: "Need it fast? Ships within 1–2 business days for a 25% express fee.", icon: "Zap" },
    ],
    features: [
      "10 mil indoor vinyl — premium satin look",
      "Vivid full-color print",
      "Up to 10 × 150 ft",
      "Free local pickup in South Florida",
    ],
    faqs: [
      { q: "What is the banner made of?",
        a: "Indoor banners are printed on smooth 10 mil indoor vinyl with a satin matte finish that flatters interior lighting and absorbs glare from overhead spotlights. The 10 mil thickness hangs flat without curling at the edges and packs well into a tube or case for trade-show travel." },
      { q: "What sizes can I order?",
        a: "Widths from 1 ft to 10 ft, lengths up to 150 ft. Pick a standard size or choose Custom and enter any dimensions within those limits. Need something even larger? Contact us for a custom oversized estimate." },
      { q: "How is the price calculated?",
        a: "Pricing is by area, with a discount on larger banners:\n\n   (Width × Height in inches) ÷ 144 × rate per sq ft\n\nRates:\n• Banners 5 ft or under on both dimensions — $5.50 / sq ft\n• Banners over 5 ft on either dimension — $4.50 / sq ft (the large-format rate)\n\nExample: a 3 ft × 6 ft banner → 36 × 72 ÷ 144 = 18 sq ft → 18 × $5.50 = $99.00. The page shows the live price as you select size or type custom dimensions." },
      { q: "What is hemming and should I add it?",
        a: "Hemming is when we fold one inch of the vinyl material over to the backside of the banner and heat-seal it to form a clean, strong 1\" hem. The hem reinforces the edge so grommets don't tear out, especially on larger banners. Hems are highly recommended — adding them costs just $10 per banner. Ordering without hems on a large banner runs the risk of the grommets tearing out of the material." },
      { q: "What are grommets and which spacing should I pick?",
        a: 'Grommets are metal rings inserted into holes through the vinyl, collared on each side to keep them held securely in place. They prevent tearing or abrasion of the material when ropes, bungee cords or zip ties are routed through the holes.\n\nFour spacing options at $2 per grommet:\n• Corner only — 4 grommets, cheapest, fine for very small banners.\n• Every 2 ft — standard for most banners.\n• Every 18 in — tighter spacing for added support.\n• Every 1 ft — heaviest hang strength, recommended for the largest banners.\n\nThe page calculates and shows the exact grommet count for your chosen size and spacing in real time.' },
      { q: "What is a pole pocket?",
        a: "A pole pocket is a sewn 4\" sleeve along the top and bottom of the banner (no grommets needed in those edges) that lets you slide a horizontal pole, dowel or pipe straight through for hanging. It gives the banner a cleaner, more retail-store look. Pole pockets are an optional add-on for $10 per banner." },
      { q: "How long until my banner arrives?",
        a: "• Regular — 5–6 business days from design approval.\n• Express — 1–2 business days for a 25% rush fee.\nLocal pickup at either Fort Lauderdale store is free as soon as the order is finished." },
      { q: "Can your team design the banner for me?",
        a: `Pick the "Let’s Print will design it for me" option at checkout. Design fees vary with size:\n• Banners up to 5 ft — $55\n• Banners over 5 ft — $75\nOur in-house team handles the full layout (logo, photos, headline copy) with proper bleed and large-format typography so it reads from across the room. 2 rounds of revisions included.` },
      { q: "Do you offer free local pickup?",
        a: "Yes — 100% free at both Fort Lauderdale stores (Broward Store at 3175 W Broward Blvd; Swap Shop Store at 3291 W Sunrise Blvd). You'll get an email/text when your order is ready." },
      { id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "We back our work with a strict Reprint Promise. If you contact us and send a photo within 5 days of delivery, we will happily reprint your order — no questions asked — if:\n• It's damaged: The items arrived bent, torn, or damaged in transit.\n• It's a production error: The final print does not match the artwork you approved or uploaded.\n\nNote: Our promise does not cover blurriness or low-quality issues resulting from low-resolution files provided or approved by the customer." },
      { q: "What file format should I upload?",
        a: 'Print-ready PDFs are best at full final banner size. We accept PDF, AI, PSD, PNG and JPG. Build artwork at 150 dpi (large banners) or 300 dpi (small banners) with 0.5" bleed on all sides. Keep important text and logos at least 2" inside the trim line — that area can be eaten into by hems or grommets. If files are huge, contact us for an upload link.' },
    ],
  },
  {
    slug: "carbonless-forms",
    name: "Carbonless Forms",
    category: "print-stationery",
    type: "carbonless-form",
    tagline: "Professional 2- and 3-part invoices and receipts.",
    description:
      "Custom carbonless NCR forms — choose 2-part (white/yellow) or 3-part (white/yellow/pink). Two sizes, full-color or Black & PMS, optional sequential numbering. Made in the USA. Free local pickup.",
    longDescription:
      "Elevate your invoices, work orders and receipts with custom branded carbonless forms from Let’s Print. Each set ships as a pad-glued booklet — your choice of 2-part (white original + yellow duplicate) or 3-part (white original + yellow duplicate + pink third copy) — so a single signature transfers cleanly to every sheet.\n\nWhy choose Let’s Print carbonless forms:\n• Two practical sizes — 8.5\" × 11\" for full invoices and estimates, and 8.5\" × 5.5\" for compact receipts.\n• 2-part or 3-part sets — pick the right copy count for your workflow (3-part is just 10% more).\n• Choose between crisp Black & PMS (1- or 2-color) or vibrant Full-Color CMYK printing.\n• Optional sequential numbering in Black or Red — perfect for audit trails and customer reference.\n• Pad-glued top edge with a clean tear so the customer copy lifts off effortlessly.\n• Order quantities from 250 sets up to 5,000 sets per run.\n\nWhether you run a service business, contracting crew, restaurant or retail counter, custom carbonless forms give every transaction a polished, on-brand finish — and give your customers a duplicate copy on the spot. Upload your own artwork or let our in-house team design a layout from your logo and key details.",
    fromPrice: 119.99,
    minQty: 250,
    designFee: 45,
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/carbonless-forms-hero.png`,
    images: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/carbonless-forms-hero.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/carbonless-forms-flat.png`,
    ],
    paperStock: "Carbonless NCR — pad-glued top edge, clean tear",
    sizes: [
      { id: "8.5x5.5", label: '8.5" × 5.5"', dim: '8.5" × 5.5"', shape: "rect-h", desc: "Compact half-letter receipts and short invoices." },
      { id: "8.5x11",  label: '8.5" × 11"',  dim: '8.5" × 11"',  shape: "rect-v", desc: "Full letter — detailed invoices, estimates and work orders." },
    ],
    partsOptions: [
      { id: "2-part", label: "2-Part",  parts: 2, multiplier: 1.00, sheets: "White / Yellow",          desc: "Original + 1 duplicate copy. Classic for receipts and quick service tickets." },
      { id: "3-part", label: "3-Part",  parts: 3, multiplier: 1.10, sheets: "White / Yellow / Pink",   desc: "Original + 2 duplicate copies. Ideal when you need a file copy plus a customer copy.", uplift: "+10%" },
    ],
    colorOptions: [
      { id: "black-pms",  label: "Black & PMS",      multiplier: 1.00, desc: "Sharp 1- or 2-color print (black plus one PMS spot color)." },
      { id: "full-color", label: "Full Color (CMYK)", multiplier: 1.15, desc: "Vibrant 4-color photographic-quality printing.", uplift: "+15%" },
    ],
    numberingOptions: [
      { id: "none",  label: "No Numbering",     multiplier: 1.00, desc: "Plain forms — no sequential numbering at the top." },
      { id: "black", label: "Black Numbering",  multiplier: 1.15, desc: "Sequential numbers printed in black at the top of each form.", uplift: "+15%" },
      { id: "red",   label: "Red Numbering",    multiplier: 1.25, desc: "Eye-catching sequential numbers printed in red at the top of each form.", uplift: "+25%" },
    ],
    quantities: [250, 500, 750, 1000, 1500, 2000, 2500, 3000, 4000, 5000],
    // NOTE: 2500 / 8.5x11 cell received as "$19.99" in the source spec — treated as a typo
    // and interpolated to $749.99 (sits cleanly between $599.99 @ 2000 and $849.99 @ 3000).
    // Base price matrix is for 2-PART forms. 3-part = +10% (applied via partsOptions multiplier).
    priceMatrix: {
      "8.5x5.5": { 250: 119.99, 500: 169.99, 750: 219.99, 1000: 259.99, 1500: 369.99, 2000: 469.99, 2500: 559.99, 3000: 659.99, 4000: 839.99, 5000:  999.99 },
      "8.5x11":  { 250: 149.99, 500: 209.99, 750: 279.99, 1000: 319.99, 1500: 459.99, 2000: 599.99, 2500: 749.99, 3000: 849.99, 4000: 999.99, 5000: 1299.99 },
    },
    productionOptions: [
      { id: "regular", label: "Regular", days: "7–8 Business Days", multiplier: 1.0, desc: "Standard turnaround. Ships within 7–8 business days of design approval.", icon: "Clock" },
      { id: "express", label: "Express", days: "4–5 Business Days", multiplier: 1.25, desc: "Need it sooner? Skip the line — your order ships within 4–5 business days for a 25% rush fee.", icon: "Zap" },
    ],
    features: [
      "2-part or 3-part NCR sets",
      "Pad-glued top edge with clean tear",
      "Top sheet transfers writing to all sheets",
      "Free local pickup in South Florida",
    ],
    faqs: [
      { q: "What's the difference between 2-part and 3-part forms?",
        a: "2-Part forms give you 2 copies per set — a white original and a yellow duplicate. They're the classic choice for receipts, simple service tickets and quick customer copies.\n\n3-Part forms give you 3 copies per set — a white original, a yellow duplicate and a pink third copy. They're ideal when you need a customer copy, a file copy and an accounting/office copy from a single transaction. 3-Part is just 10% more than 2-Part across every size and quantity." },
      { q: "What's included in each set?",
        a: "Every carbonless form set is a pad-glued booklet — your choice of 2-part (white + yellow) or 3-part (white + yellow + pink). Whatever you write on the top white sheet automatically transfers — through pressure-sensitive coating — to the sheets below. Sets tear apart cleanly along the glued edge." },
      { q: "What sizes do you offer?",
        a: 'Two popular sizes:\n• 8.5" × 5.5" — compact half-letter, ideal for receipts, quick work orders and tip slips.\n• 8.5" × 11" — full letter, ideal for detailed invoices, estimates, contracts and service tickets.' },
      { q: "What's the difference between Black & PMS and Full Color?",
        a: "Black & PMS is a 1- or 2-color print using black ink plus one PMS spot color — clean, professional and the most economical option. Full Color (CMYK) uses 4-color process printing for photographic-quality artwork and unlimited color variety. Full Color adds 15% to the base price." },
      { q: "Do you offer sequential numbering?",
        a: "Yes. You can add sequential numbering at the top of every form:\n• No Numbering — plain forms (no extra cost).\n• Black Numbering — clean black numerals, +15%.\n• Red Numbering — eye-catching red numerals, +25%.\nNumbering is sequential across the entire run and continues from where you left off on reorders if you let us know your last number." },
      { q: "How does the pricing work?",
        a: 'Pricing depends on size, parts (2-part vs 3-part), color option, numbering choice and quantity. The smallest entry point is 250 sets of 8.5"×5.5" Black & PMS 2-part at $119.99, and the largest is 5,000 sets of 8.5"×11" 2-part at $1,299.99 (3-part is +10%). The sticky summary on the page updates live as you change options, so you\'ll always see the exact total before checkout.' },
      { q: "How long until my forms arrive?",
        a: "Two production options:\n• Regular — 7–8 business days from design approval, plus shipping.\n• Express — 4–5 business days for a 25% rush fee added at checkout.\nLocal pickup at either of our Fort Lauderdale stores is free and available as soon as your order is finished." },
      { q: "Can your team design the forms for me?",
        a: `Yes. Pick the "Let’s Print will design it for me" option for a one-time $45 graphic design fee. Our in-house team will lay out your logo, contact info, terms and any custom fields you need. Two rounds of revisions are included.` },
      { q: "Do you offer free local pickup?",
        a: "Yes — local pickup is 100% free at both of our Fort Lauderdale locations (Broward Store at 3175 W Broward Blvd, and Swap Shop Store at 3291 W Sunrise Blvd). You'll get an email/text the moment your order is ready." },
      { id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "We back our work with a strict Reprint Promise. If you contact us and send a photo within 5 days of delivery, we will happily reprint your order — no questions asked — if:\n• It's damaged: The booklets arrived bent, torn or damaged in transit.\n• It's a production error: The final print does not match the artwork you approved or uploaded.\n\nNote: Our promise does not cover blurriness or low-quality issues resulting from low-resolution files provided or approved by the customer." },
      { q: "What file format should I upload?",
        a: 'Print-ready PDFs are best, but we also accept high-resolution PNG, JPG, AI and PSD files. Include 0.125" bleed on all sides at 300 dpi, and keep critical text and logos at least 0.25" inside the trim line. If you have sequential numbering, please leave a clearly marked numbering placeholder area at the top of the form so we know where to drop in the numbers.' },
    ],
  },
  {
    slug: "waterproof-vinyl-labels",
    name: "Waterproof Vinyl Labels",
    category: "labels-stickers",
    type: "standard-label",
    tagline: "Waterproof. Vibrant. Built to last.",
    description:
      "Premium 4Mil digital vinyl stickers with waterproof adhesive. 10 popular shapes plus 1\", 2\" and 3\" circles. Made in the USA. Free local pickup.",
    longDescription:
      "Boost your brand's visibility with custom waterproof vinyl stickers from Let’s Print — the perfect blend of impact, durability and cost-effectiveness. Designed for small businesses, product labeling, giveaways and promotional campaigns, these stickers keep your brand looking sharp in any setting.\n\nCrafted from high-quality 4Mil digital vinyl, our stickers are built to withstand everyday wear while maintaining vibrant, eye-catching colors. The waterproof adhesive makes them perfect for indoor applications and limited outdoor use, so you can promote your brand wherever it counts.\n\nKey features:\n• Premium 4Mil digital vinyl — strong, resilient and made to last\n• Waterproof adhesive — protects your design from moisture and wear\n• Cost-effective marketing — high impact without high costs\n• Easy customization — upload your design and pick from a variety of shapes and sizes\n• Professional proofing — our print experts review every file for flawless results\n• Flexible size & shape options — match your stickers to your brand's needs\n\nPerfect for product labeling and packaging, event giveaways and trade shows, brand swag for customers and fans, and indoor signage and promotions.",
    fromPrice: 39.99,
    minQty: 25,
    designFee: 35,
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/waterproof-vinyl-labels-hero.png`,
    images: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/waterproof-vinyl-labels-hero.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/waterproof-vinyl-labels-flat.png`,
    ],
    paperStock: "4Mil Digital Vinyl",
    sizes: [
      { id: "2x2",      label: '2" × 2"',     dim: '2" × 2"',     shape: "square", desc: "Square logo / icon sticker." },
      { id: "2x3.5",    label: '2" × 3.5"',   dim: '2" × 3.5"',   shape: "rect-h", desc: "Classic business-card sticker." },
      { id: "2x4",      label: '2" × 4"',     dim: '2" × 4"',     shape: "rect-h", desc: "Long product strip sticker." },
      { id: "3.5x3.5",  label: '3.5" × 3.5"', dim: '3.5" × 3.5"', shape: "square", desc: "Medium square brand sticker." },
      { id: "3x4",      label: '3" × 4"',     dim: '3" × 4"',     shape: "rect-h", desc: "Compact rectangular sticker." },
      { id: "2x8",      label: '2" × 8"',     dim: '2" × 8"',     shape: "rect-h", desc: "Tall bottle / wrap sticker." },
      { id: "3x6",      label: '3" × 6"',     dim: '3" × 6"',     shape: "rect-h", desc: "Tall jar sticker." },
      { id: "4x4",      label: '4" × 4"',     dim: '4" × 4"',     shape: "square", desc: "Large square sticker." },
      { id: "4x6",      label: '4" × 6"',     dim: '4" × 6"',     shape: "rect-h", desc: "Postcard-size sticker." },
      { id: "8.5x11",   label: '8.5" × 11"',  dim: '8.5" × 11"',  shape: "rect-v", desc: "Full letter-size sticker sheet." },
      { id: "circle-1", label: '1" Circle',   dim: '1" × 1"',     shape: "circle", desc: "Small round badge sticker (in-house Avery stock)." },
      { id: "circle-2", label: '2" Circle',   dim: '2" × 2"',     shape: "circle", desc: "Standard round logo sticker." },
      { id: "circle-3", label: '3" Circle',   dim: '3" × 3"',     shape: "circle", desc: "Bold round brand sticker." },
    ],
    quantities: [25, 50, 100, 250, 500],
    priceMatrix: {
      "2x2":      { 25: 39.99,  50: 49.99,  100: 59.99,  250: 99.99,  500: 179.99 },
      "2x3.5":    { 25: 39.99,  50: 49.99,  100: 59.99,  250: 99.99,  500: 179.99 },
      "2x4":      { 25: 39.99,  50: 49.99,  100: 69.99,  250: 119.99, 500: 199.99 },
      "3.5x3.5":  { 25: 49.99,  50: 69.99,  100: 89.99,  250: 149.99, 500: 279.99 },
      "3x4":      { 25: 49.99,  50: 69.99,  100: 89.99,  250: 149.99, 500: 279.99 },
      "2x8":      { 25: 79.99,  50: 99.99,  100: 149.99, 250: 269.99, 500: 499.99 },
      "3x6":      { 25: 79.99,  50: 99.99,  100: 149.99, 250: 269.99, 500: 499.99 },
      "4x4":      { 25: 79.99,  50: 99.99,  100: 149.99, 250: 269.99, 500: 499.99 },
      "4x6":      { 25: 89.99,  50: 129.99, 100: 199.99, 250: 399.99, 500: 699.99 },
      "8.5x11":   { 25: 239.99, 50: 299.99, 100: 479.99, 250: 899.99, 500: 1699.99 },
      "circle-1": { 25: 99.99,  50: 119.99, 100: 149.99, 250: 249.99, 500: 449.99 },
      "circle-2": { 25: 99.99,  50: 119.99, 100: 149.99, 250: 249.99, 500: 449.99 },
      "circle-3": { 25: 129.99, 50: 159.99, 100: 229.99, 250: 399.99, 500: 599.99 },
    },
    productionOptions: [
      { id: "regular", label: "Regular", days: "5–6 Business Days", multiplier: 1.0, desc: "Standard turnaround. Ships within 5–6 business days of design approval.", icon: "Clock" },
      { id: "express", label: "Express", days: "1–2 Business Days", multiplier: 1.25, desc: "Need it fast? Skip the line — your order ships within 1–2 business days for a 25% rush fee.", icon: "Zap" },
    ],
    features: [
      "4Mil premium digital vinyl",
      "Waterproof adhesive",
      "Vibrant, fade-resistant inks",
      "Free local pickup in South Florida",
    ],
    faqs: [
      { q: "What material are these stickers printed on?",
        a: "Waterproof Vinyl Stickers are printed on premium 4Mil digital vinyl — a strong, resilient sticker material with a waterproof adhesive backing protected by a peel-off liner. The vinyl surface holds vivid, high-resolution color and stands up to daily handling, splashes and humidity." },
      { q: "Are these stickers actually waterproof?",
        a: "Yes. The vinyl face and adhesive are waterproof, so the print won't smear or peel from incidental moisture, condensation, hand washing or refrigerator humidity. They're ideal for indoor use and limited outdoor use (think product packaging, water bottles, laptops, coolers, lockers). For permanent, full-time outdoor signage in direct sun, we recommend our UV-laminated sticker upgrade." },
      { q: "What sizes and shapes do you offer?",
        a: '10 rectangular / square sizes plus 3 die-cut circle sizes:\n• 2" × 2"  · 2" × 3.5"  · 2" × 4"\n• 3.5" × 3.5"  · 3" × 4"\n• 2" × 8"  · 3" × 6"\n• 4" × 4"  · 4" × 6"\n• 8.5" × 11" (full letter sheet)\n• 1" Circle  · 2" Circle  · 3" Circle\nThe 1" circle is produced in-house on Avery stock. Need a fully custom shape we don\'t list? Contact us for a quote — custom die-cut shapes are available.' },
      { q: "How does the pricing work?",
        a: "Pricing depends on size and quantity. The smallest entry point is 25 stickers at $39.99, and the largest is 500 sticker sheets at 8.5\" × 11\" for $1,699.99. The price table on the page updates live based on the size you pick, so you'll always see the exact total before checkout." },
      { q: "What surfaces will these stickers stick to?",
        a: "They adhere to most smooth, clean, room-temperature surfaces — glass bottles, plastic containers, metal cans, painted walls, laptops, lockers, water bottles, coolers and packaging. They will not stick reliably to rough, oily, dirty, freezing-cold or freshly painted surfaces. Test on a small area first if you're unsure about your substrate." },
      { q: "How long until my stickers arrive?",
        a: "Two production options:\n• Regular — 5–6 business days from design approval, plus shipping.\n• Express — 1–2 business days for a 25% rush fee added at checkout.\nLocal pickup at either of our Fort Lauderdale stores is free and available as soon as your order is finished." },
      { q: "Can your team design the stickers for me?",
        a: `Yes. Pick the "Let’s Print will design it for me" option for a one-time $35 graphic design fee. Our in-house print experts will craft a sticker layout from your logo, brand colors and key copy — with proper bleed and the correct die-cut line for your chosen shape. Two rounds of revisions are included.` },
      { q: "Do you offer free local pickup?",
        a: "Yes — local pickup is 100% free at both of our Fort Lauderdale locations (Broward Store at 3175 W Broward Blvd, and Swap Shop Store at 3291 W Sunrise Blvd). You'll get an email/text the moment your order is ready." },
      { id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "We back our work with a strict Reprint Promise. If you contact us and send a photo within 5 days of delivery, we will happily reprint your order — no questions asked — if:\n• It's damaged: The items arrived bent, torn or damaged in transit.\n• It's a production error: The final print does not match the artwork you approved or uploaded.\n\nNote: Our promise does not cover blurriness or low-quality issues resulting from low-resolution files provided or approved by the customer." },
      { q: "What file format should I upload?",
        a: 'Print-ready PDFs are best, but we also accept high-resolution PNG, JPG, AI and PSD files. Include 0.125" bleed on all sides at 300 dpi, and keep critical text and logos at least 0.125" inside the trim line. For circles or any custom die-cut shape, send a vector file (PDF or AI) with the cut line marked as a separate spot color layer.' },
    ],
  },
  {
    slug: "standard-labels",
    name: "Standard Labels (Crack & Peel)",
    category: "labels-stickers",
    type: "standard-label",
    tagline: "Custom labels printing — fast, high-quality, eye-catching.",
    description:
      "Vibrant full-color crack-and-peel labels printed on 70lb adhesive sticker paper. 10 popular sizes, 8 quantity tiers. Made in the USA. Free local pickup.",
    longDescription:
      "Promote your product or service with professionally printed custom labels from Let’s Print. From branding and packaging to promotions and events, our high-quality labels are designed to make your message stand out on any smooth surface.\n\nWith custom sizes, durable materials, and vibrant full-color printing, Let’s Print Labels help businesses boost brand recognition, highlight product benefits, and create eye-catching packaging that drives sales.\n\nWhy choose Let’s Print custom labels:\n• Custom shapes available for all sticker and label types\n• 1–2 business day rush options available\n• Strong adhesive for reliable, long-lasting application\n• Crisp, high-resolution printing with rich, accurate colors\n\nWe prioritize quality at every step. Our labels are produced using professional printing standards to ensure consistent results, durable construction, and dependable adhesive strength — so you never have to worry about peeling, fading, or wear.\n\nUse custom labels to enhance product packaging, add branding and visual appeal, communicate key product details, and create promotional or decorative stickers. Bright, colorful labels are proven to attract attention — and Let’s Print helps you make a strong first impression.",
    fromPrice: 29.99,
    minQty: 25,
    designFee: 35,
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/standard-labels-hero.png`,
    images: [
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/standard-labels-hero.png`,
      `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/standard-labels-flat.png`,
    ],
    paperStock: "70lb adhesive sticker paper",
    sizes: [
      { id: "2x2",      label: '2" × 2"',     dim: '2" × 2"',     shape: "square", desc: "Square logo / icon labels." },
      { id: "2x3.5",    label: '2" × 3.5"',   dim: '2" × 3.5"',   shape: "rect-h", desc: "Classic business-card label." },
      { id: "2x4",      label: '2" × 4"',     dim: '2" × 4"',     shape: "rect-h", desc: "Long product strip label." },
      { id: "3.5x3.5",  label: '3.5" × 3.5"', dim: '3.5" × 3.5"', shape: "square", desc: "Medium square brand sticker." },
      { id: "3x4",      label: '3" × 4"',     dim: '3" × 4"',     shape: "rect-h", desc: "Compact rectangular label." },
      { id: "2x8",      label: '2" × 8"',     dim: '2" × 8"',     shape: "rect-h", desc: "Tall bottle / wrap label." },
      { id: "3x6",      label: '3" × 6"',     dim: '3" × 6"',     shape: "rect-h", desc: "Tall jar label." },
      { id: "4x4",      label: '4" × 4"',     dim: '4" × 4"',     shape: "square", desc: "Large square sticker." },
      { id: "4x6",      label: '4" × 6"',     dim: '4" × 6"',     shape: "rect-h", desc: "Postcard-size label." },
      { id: "8.5x11",   label: '8.5" × 11"',  dim: '8.5" × 11"',  shape: "rect-v", desc: "Full letter-size label sheet." },
    ],
    quantities: [25, 50, 75, 100, 250, 500, 1000, 2500],
    priceMatrix: {
      "2x2":     { 25: 29.99,  50: 49.99,  75: 59.99,  100: 69.99,  250: 99.99,  500: 129.99, 1000: 179.99, 2500: 299.99 },
      "2x3.5":   { 25: 29.99,  50: 49.99,  75: 59.99,  100: 69.99,  250: 99.99,  500: 129.99, 1000: 179.99, 2500: 299.99 },
      "2x4":     { 25: 44.99,  50: 79.99,  75: 109.99, 100: 139.99, 250: 189.99, 500: 299.99, 1000: 329.99, 2500: 549.99 },
      "3.5x3.5": { 25: 49.99,  50: 79.99,  75: 109.99, 100: 139.99, 250: 189.99, 500: 299.99, 1000: 329.99, 2500: 549.99 },
      "3x4":     { 25: 49.99,  50: 79.99,  75: 109.99, 100: 139.99, 250: 189.99, 500: 299.99, 1000: 329.99, 2500: 549.99 },
      "2x8":     { 25: 49.99,  50: 99.99,  75: 149.99, 100: 199.99, 250: 219.99, 500: 399.99, 1000: 549.99, 2500: 659.99 },
      "3x6":     { 25: 49.99,  50: 99.99,  75: 149.99, 100: 199.99, 250: 219.99, 500: 390.99, 1000: 549.99, 2500: 659.99 },
      "4x4":     { 25: 49.99,  50: 99.99,  75: 149.99, 100: 199.99, 250: 219.99, 500: 399.99, 1000: 469.99, 2500: 619.99 },
      "4x6":     { 25: 59.99,  50: 109.99, 75: 159.99, 100: 219.99, 250: 229.99, 500: 419.99, 1000: 569.99, 2500: 799.99 },
      "8.5x11":  { 25: 139.99, 50: 269.99, 75: 419.99, 100: 539.99, 250: 559.99, 500: 1009.99, 1000: 1399.99, 2500: 1599.99 },
    },
    productionOptions: [
      { id: "regular", label: "Regular", days: "5–6 Business Days", multiplier: 1.0, desc: "Standard turnaround. Ships within 5–6 business days of design approval.", icon: "Clock" },
      { id: "express", label: "Express", days: "1–2 Business Days", multiplier: 1.25, desc: "Need it fast? Skip the line — your order ships within 1–2 business days for a 25% rush fee.", icon: "Zap" },
    ],
    features: [
      "70lb adhesive sticker paper",
      "Crisp full-color printing",
      "Strong, long-lasting adhesive",
      "Free local pickup in South Florida",
    ],
    faqs: [
      { q: "What paper are the labels printed on?",
        a: "Standard Crack & Peel Labels are printed on a 70lb adhesive sticker paper. The paper sheet has a permanent, pressure-sensitive adhesive backing protected by a glossy release liner that you crack and peel off when you're ready to apply." },
      { q: "Are these labels waterproof?",
        a: "No — Crack & Peel labels are paper-based and are not waterproof. They're perfect for indoor product packaging, branding, retail displays, mailing labels and promotional stickers, but they aren't designed for prolonged outdoor weather or exposure to liquids. If you need waterproof labels, look at our vinyl sticker options instead." },
      { q: "What sizes do you offer?",
        a: '10 popular sizes:\n• 2" × 2"  · 2" × 3.5"  · 2" × 4"\n• 3.5" × 3.5"  · 3" × 4"\n• 2" × 8"  · 3" × 6"\n• 4" × 4"  · 4" × 6"\n• 8.5" × 11" (full letter sheet)\nPick the size that matches your product. Need a custom shape or size we don\'t list? Contact us for a quote — custom shapes are available for all sticker and label types.' },
      { q: "What surfaces will these labels stick to?",
        a: "They are designed for smooth, clean, room-temperature surfaces — glass bottles, plastic containers, cardboard boxes, books, lockers, laptops, packaging, mailers, etc. They will not stick reliably to rough, oily, dirty, freezing cold or freshly painted surfaces. Always test on a small area first if you're unsure about your substrate." },
      { q: "How does the pricing work?",
        a: "Pricing depends on size and quantity. The smallest entry point is 25 labels at $29.99 (for 2\" sizes), and the largest is 2,500 labels at 8.5\"×11\" for $1,599.99. The price table on the page updates live based on the size you pick, so you'll always see the exact total before checkout." },
      { q: "How long until my labels arrive?",
        a: "Two options:\n• Regular — 5–6 business days from design approval, plus shipping.\n• Express — 1–2 business days for a 25% rush fee added at checkout.\nLocal pickup at either of our Fort Lauderdale stores is free and available as soon as the order is finished." },
      { q: "Can your team design the labels for me?",
        a: `Yes. Pick the "Let’s Print will design it for me" option at checkout for a one-time $35 graphic design fee. Our in-house team will craft a label layout from your logo, brand colors and key copy, with two rounds of revisions included. We design with proper bleed and the correct cut line for your chosen size.` },
      { q: "Do you offer free local pickup?",
        a: "Yes — local pickup is 100% free at both of our Fort Lauderdale locations (Broward Store at 3175 W Broward Blvd, and Swap Shop Store at 3291 W Sunrise Blvd). You'll get an email/text when your order is ready." },
      { id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "We back our work with a strict Reprint Promise. If you contact us and send a photo within 5 days of delivery, we will happily reprint your order — no questions asked — if:\n• It's damaged: The items arrived bent, torn, or damaged in transit.\n• It's a production error: The final print does not match the artwork you approved or uploaded.\n\nNote: Our promise does not cover blurriness or low-quality issues resulting from low-resolution files provided or approved by the customer." },
      { q: "What file format should I upload?",
        a: 'Print-ready PDFs are best, but we also accept high-resolution PNG, JPG, AI and PSD files. Include 0.125" bleed on all sides at 300 dpi, and keep critical text and logos at least 0.125" inside the trim line. If you have a complex custom shape, send a vector file (PDF or AI) with the cut line marked as a separate spot color layer.' },
    ],
  },
  // ─────────── All-In-One Printing — AIO Business Starter ───────────
  {
    slug: "aio-business-starter",
    name: "AIO Business Starter",
    category: "marketing-material",        // primary slot — lives under Marketing Material → All In One
    secondaryCategory: "pre-clothes-printing",  // also surfaced under Apparel & T-Shirts
    type: "aio-business-starter",
    tagline: "Everything your new business needs in one bundle. Brand. Print. Wear. Go live.",
    description:
      "Launch your new business in one shot. 500 business cards, 500 flyers (or 250 brochures), 2 car magnets, 2 custom polo shirts, plus a free logo, QR code, e-business card and NFC bonus pack — all designed and printed by Let's Print.",
    longDescription:
      "The AIO Business Starter is built for entrepreneurs who want their brand live on day one — no juggling vendors, no design back-and-forth, no surprise upcharges.\n\nWhat's in the bundle:\n• 500 Standard Business Cards — full color, 16pt cardstock, designed by our team.\n• Choose ONE of: 500 Flyers (4×6, 100lb gloss) OR 250 Brochures (8.5×11 tri-fold).\n• 2 Car Magnets (12\" × 18\" or equivalent) — perfect for service businesses.\n• 2 Custom Polo Shirts with your logo embroidered or DTF-printed.\n• FREE Logo Design — three concept rounds, you pick the winner.\n• FREE QR Code that links to your e-business card.\n• FREE E-Business Card — a shareable digital profile.\n• FREE NFC Bonus Pack — tap-to-share contact technology.\n• White-glove setup: we handle the design, you approve the proofs.\n\nUpgrade polo sizes if needed — XS through XL are included, larger sizes (2XL–5XL) add a small per-shirt fee. Pickup or local Broward delivery available.",
    // Pricing — flat package + per-shirt size surcharge handled in the configurator.
    fromPrice: 499,
    regularPrice: 899,
    minQty: 1,
    designFee: 0,
    image: "https://customer-assets.emergentagent.com/job_print-migration-1/artifacts/wq66k2j4_AIO_PACKAGE_Optimized.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_print-migration-1/artifacts/wq66k2j4_AIO_PACKAGE_Optimized.jpg",
    ],
    inclusions: [
      "500 Business Cards (16pt, full color)",
      "500 Flyers (4×6) OR 250 Brochures (8.5×11)",
      "2 Car Magnets (12\" × 18\")",
      "2 Custom Polo Shirts with your logo",
      "FREE Logo Design",
      "FREE QR Code",
      "FREE E-Business Card",
      "FREE NFC Bonus Pack",
      "FREE Design & Setup",
    ],
    // Used by CategoryPage card grid (renders the first 3 as bullets).
    features: [
      "Everything for $499 (was $899)",
      "FREE Logo + Design + Setup",
      "Polo size upgrades from 2XL onwards",
    ],
    // Configurator options consumed by AioBusinessStarterPage.jsx.
    options: {
      printChoice: [
        { id: "flyers-500", label: "500 Flyers (4×6, 100lb gloss)" },
        { id: "brochures-250", label: "250 Brochures (8.5×11 tri-fold)" },
      ],
      poloSizes: [
        { id: "S", label: "Small (S)", surcharge: 0 },
        { id: "M", label: "Medium (M)", surcharge: 0 },
        { id: "L", label: "Large (L)", surcharge: 0 },
        { id: "XL", label: "X-Large (XL)", surcharge: 0 },
        { id: "2XL", label: "2XL (+$5)", surcharge: 5 },
        { id: "3XL", label: "3XL (+$10)", surcharge: 10 },
        { id: "4XL", label: "4XL (+$15)", surcharge: 15 },
        { id: "5XL", label: "5XL (+$20)", surcharge: 20 },
      ],
    },
    faqs: [
      { q: "What exactly do I get for $499?",
        a: "Everything listed in the bundle: 500 full-color 16pt business cards, your choice of 500 flyers (4×6, 100lb gloss) or 250 brochures (8.5×11 tri-fold), 2 car magnets (12\"×18\"), 2 custom polo shirts with your logo, plus free logo design, QR code, e-business card and NFC bonus pack. White-glove design and setup are included — no hidden fees." },
      { q: "How long does the whole package take?",
        a: "Once you place the order, you'll get your first round of logo concepts within 2–3 business days. After you approve the logo and proofs (cards, flyers/brochures, magnets and shirts), production runs 5–7 business days. Most customers are fully kitted out within 2 weeks." },
      { q: "Can I upgrade polo sizes?",
        a: "Yes. Sizes S–XL are included in the $499 price. 2XL adds $5/shirt, 3XL +$10, 4XL +$15 and 5XL +$20. The configurator updates the total live as you pick sizes for each of the two shirts." },
      { q: "Can I swap items in the bundle for something else?",
        a: "The bundle is a fixed package designed to give new businesses the best launch value. The only configurable swap is 500 flyers vs. 250 brochures, plus polo sizes. If you need custom quantities or different items, contact us and we'll quote a custom starter pack." },
      { q: "Do I have to provide my own logo design?",
        a: "No — free logo design is part of the bundle. Our designers will present 3 concept rounds based on your brief, you pick the winner, and we use that logo across every printed item, the QR code and your e-business card." },
      { q: "How do delivery and pickup work?",
        a: "Free local pickup is available from our Broward County print shop. We also offer paid local delivery across Broward and standard shipping nationwide — the rate is calculated at checkout or quoted before production starts." },
      { id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "Every Let's Print order is backed by our Reprint Promise. If you receive your AIO bundle and any printed item is damaged in transit or doesn't match the proof you approved, send us a photo within 5 days of delivery and we'll reprint that item — no questions asked. The promise doesn't cover issues caused by low-resolution files you supplied and approved." },
    ],
  },
  // ─────────────── Gang Sheet Printing ───────────────
  // 22"-wide gang-sheet rolls priced per-length (see `sizeOptions`).
  // Both products share the same configurator (`GangSheetProductPage`);
  // the only differences are the size list, art image and category display.
  {
    slug: "dtf-gang-sheet",
    name: "DTF Gang Sheet",
    category: "marketing-material",
    subCategory: "gang-sheet-printing",
    type: "gang-sheet",
    tagline: "22\" wide DTF transfers, priced per length. Ready in 24–48 hours.",
    description: "High-quality Direct-to-Film (DTF) gang sheet transfers on our commercial 22-inch DTF printer. Vibrant, wash-durable prints ready to heat-press onto cotton, poly, blends, denim and more. Pack your artwork edge-to-edge to maximise your sheet — you get everything you gang up.",
    longDescription: "Direct-to-Film (DTF) is the most versatile transfer method available for custom apparel and merch. Our 22\"-wide gang sheets let you fit multiple logos, names or designs on a single continuous run — pay per length, not per design. Full-color CMYK + white ink, wash-tested to 50+ cycles, works on cotton, polyester, blends, denim, canvas, tote bags and more. Just heat-press at 305°F for 12 seconds, peel warm, then finish with 5s at 315°F.\n\nFast local production in Broward — most orders ship within 24–48 hours of proof approval.",
    image: "https://customer-assets.emergentagent.com/job_print-migration-1/artifacts/0anp9m1g_1000817604.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_print-migration-1/artifacts/0anp9m1g_1000817604.jpg",
    ],
    features: [
      "22\" wide continuous roll — gang up unlimited designs",
      "Full-color CMYK + white ink",
      "Wash-durable to 50+ cycles at 40°C",
      "Works on cotton, poly, blends, denim, canvas & more",
      "Ready in 24–48 hours after proof approval",
      "Free local pickup · flat-rate Broward delivery $24.99",
    ],
    sizeUnitNote: "All sizes are 22 inches wide",
    sizeGuideNote: "Gang sheet width should be 22\" (6600px) with 300 DPI.",
    // Prices sourced from user's DTF pricing spreadsheet.
    sizeOptions: [
      { size: "22x12",   inches: 12,   priceCents: 1499 },
      { size: "22x24",   inches: 24,   priceCents: 1999 },
      { size: "22x36",   inches: 36,   priceCents: 2999 },
      { size: "22x48",   inches: 48,   priceCents: 4399 },
      { size: "22x60",   inches: 60,   priceCents: 5099 },
      { size: "22x72",   inches: 72,   priceCents: 6399 },
      { size: "22x84",   inches: 84,   priceCents: 7399 },
      { size: "22x96",   inches: 96,   priceCents: 8799 },
      { size: "22x108",  inches: 108,  priceCents: 9399 },
      { size: "22x132",  inches: 132,  priceCents: 11799 },
      { size: "22x144",  inches: 144,  priceCents: 12599 },
      { size: "22x156",  inches: 156,  priceCents: 13799 },
      { size: "22x168",  inches: 168,  priceCents: 14499 },
      { size: "22x180",  inches: 180,  priceCents: 15399 },
      { size: "22x190",  inches: 190,  priceCents: 16199 },
      { size: "22x204",  inches: 204,  priceCents: 17499 },
      { size: "22x224",  inches: 224,  priceCents: 22299 },
      { size: "22x300",  inches: 300,  priceCents: 24999 },
      { size: "22x350",  inches: 350,  priceCents: 27999 },
      { size: "22x400",  inches: 400,  priceCents: 31999 },
      { size: "22x500",  inches: 500,  priceCents: 35999 },
      { size: "22x700",  inches: 700,  priceCents: 50999 },
      { size: "22x1000", inches: 1000, priceCents: 67999 },
    ],
    faqs: [
      { q: "What file format should I upload?",
        a: "PNG on transparent background is ideal (300 DPI). We also accept high-res JPEG, PDF and TIFF. Make sure your artwork fits inside 22 inches wide with your chosen length. Pack designs as tight as you can — you're paying per length, so wasted whitespace = wasted money." },
      { q: "What temperature and pressure do I press at?",
        a: "Standard DTF press: 305°F for 12 seconds at medium pressure, peel warm (after ~10s cool-down), then a final press for 5 seconds at 315°F with a Teflon sheet. Works reliably on 100% cotton, 100% poly, blends, tri-blends and most denim." },
      { q: "How long do the transfers last?",
        a: "Wash-tested to 50+ cycles at 40°C on cotton and poly-cotton blends. Don't tumble dry on high heat and turn garments inside-out for best longevity." },
      { q: "Do you provide a proof before printing?",
        a: "Yes — we send a digital layout proof within a few hours for you to approve. Production only starts once you sign off." },
      { q: "How fast can I get my order?",
        a: "Most DTF gang sheets are printed and ready within 24–48 hours of proof approval. Free local pickup at 3175 W Broward Blvd or flat-rate $24.99 Broward delivery." },
      { id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "We back every DTF gang sheet with our Reprint Promise. If your sheet arrives damaged in transit or the print doesn't match the proof you approved, send us a photo within 5 days and we'll reprint the entire order — no questions asked. The promise covers production mistakes and transit damage only; it doesn't cover issues from low-resolution files that you supplied and approved." },
    ],
  },
  {
    slug: "uv-sticker-gang-sheet",
    name: "UV Sticker Gang Sheet",
    category: "marketing-material",
    subCategory: "gang-sheet-printing",
    type: "gang-sheet",
    tagline: "22\" wide UV-printed sticker sheets. Waterproof, weatherproof, ready in 48 hours.",
    description: "Full-color UV-printed sticker gang sheets on premium waterproof vinyl with a permanent adhesive backing. Kiss-cut ready — peel and stick anywhere. Gang up unlimited logos, labels or die-cut designs on a single 22\"-wide sheet.",
    longDescription: "Premium UV-cured sticker gang sheets, printed on 3mil white waterproof vinyl with permanent acrylic adhesive. UV inks deliver true CMYK + white color that resists fading, water, alcohol, dishwashers, weather and light abrasion. Perfect for product labels, laptops, water bottles, hard hats, tumblers, vehicle windows and outdoor signage.\n\nAll sheets come kiss-cut around each design — just peel off the piece you need and stick. Ready in 48 hours from proof approval.",
    image: "https://customer-assets.emergentagent.com/job_print-migration-1/artifacts/dvqsh1i6_1000817605.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_print-migration-1/artifacts/dvqsh1i6_1000817605.jpg",
    ],
    features: [
      "22\" wide UV-cured sticker sheets",
      "Waterproof, weatherproof, dishwasher-safe",
      "Kiss-cut around every design — peel & stick",
      "True CMYK + white ink on 3mil vinyl",
      "Permanent acrylic adhesive",
      "Ready in 48 hours after proof approval",
    ],
    sizeUnitNote: "All sizes are 22 inches wide",
    sizeGuideNote: "Sheet width should be 22\" (6600px) with 300 DPI. Add a 0.125\" bleed around every design.",
    // Prices sourced from user's UV Stickers pricing spreadsheet.
    sizeOptions: [
      { size: "22x12",   inches: 12,   priceCents: 2400 },
      { size: "22x24",   inches: 24,   priceCents: 4800 },
      { size: "22x36",   inches: 36,   priceCents: 7200 },
      { size: "22x48",   inches: 48,   priceCents: 9600 },
      { size: "22x60",   inches: 60,   priceCents: 12000 },
      { size: "22x72",   inches: 72,   priceCents: 14400 },
      { size: "22x84",   inches: 84,   priceCents: 16800 },
      { size: "22x96",   inches: 96,   priceCents: 19200 },
      { size: "22x108",  inches: 108,  priceCents: 12600 },
      { size: "22x120",  inches: 120,  priceCents: 24000 },
      { size: "22x132",  inches: 132,  priceCents: 26400 },
      { size: "22x144",  inches: 144,  priceCents: 28800 },
      { size: "22x156",  inches: 156,  priceCents: 31200 },
      { size: "22x168",  inches: 168,  priceCents: 33600 },
      { size: "22x180",  inches: 180,  priceCents: 36000 },
      { size: "22x192",  inches: 192,  priceCents: 38400 },
      { size: "22x204",  inches: 204,  priceCents: 20800 },
      { size: "22x216",  inches: 216,  priceCents: 43800 },
      { size: "22x228",  inches: 228,  priceCents: 45600 },
      { size: "22x240",  inches: 240,  priceCents: 48000 },
      { size: "22x252",  inches: 252,  priceCents: 50400 },
      { size: "22x264",  inches: 264,  priceCents: 52800 },
      { size: "22x276",  inches: 276,  priceCents: 55200 },
      { size: "22x288",  inches: 288,  priceCents: 57600 },
      { size: "22x300",  inches: 300,  priceCents: 60000 },
    ],
    faqs: [
      { q: "What material are the stickers printed on?",
        a: "3mil premium white waterproof vinyl with a permanent acrylic adhesive backing. UV inks bond into the vinyl for true weather-resistance." },
      { q: "Are they truly weatherproof?",
        a: "Yes — UV-cured inks on waterproof vinyl. They survive rain, sun, dishwashers, alcohol wipes, freezer temperatures and outdoor exposure. Rated 5+ years outdoors." },
      { q: "How are the stickers cut?",
        a: "Every design is kiss-cut — the vinyl top layer is cut through, but the paper backing stays intact. Peel off just the sticker you want and stick it anywhere." },
      { q: "What file format should I upload?",
        a: "PNG on transparent background (300 DPI) is ideal. We also accept PDF, TIFF and high-res JPEG. Add 0.125\" bleed around each design if you want the color to run to the cut edge." },
      { q: "How fast can I get my order?",
        a: "Most UV sticker gang sheets are printed and ready within 48 hours of proof approval. Free local pickup or flat-rate $24.99 Broward delivery." },
      { id: "reprint-promise",
        q: "What is your Reprint Promise?",
        a: "We back every UV sticker sheet with our Reprint Promise. If your sheet arrives damaged in transit or the print doesn't match the proof you approved, send us a photo within 5 days and we'll reprint the entire order — no questions asked. The promise covers production mistakes and transit damage only; it doesn't cover issues from low-resolution files that you supplied and approved." },
    ],
  },
];

export const REVIEWS = [
  { name: "Maria S.", date: "2 days ago", rating: 5, text: "Print quality is unreal. The square business cards arrived perfect — heavy stock, vibrant colors. Will reorder." },
  { name: "Daniel R.", date: "5 days ago", rating: 5, text: "Ordered yard signs for my campaign. Fast turnaround, great communication and the H-stakes were included." },
  { name: "Selene W.", date: "1 week ago", rating: 5, text: "From the design help to the final delivery — Let’s Print made it ridiculously easy. Custom stickers came out gorgeous." },
  { name: "James L.", date: "1 week ago", rating: 4, text: "Good quality vinyl banner. Slight delay on delivery but the team kept me updated." },
  { name: "Olive H.", date: "2 weeks ago", rating: 5, text: "Recommend to everyone! Print quality is excellent — DTF prints came out crisp and vibrant." },
  { name: "Susana L.", date: "3 weeks ago", rating: 5, text: "Years of using Let’s Print, and they keep raising the bar. Best print shop I've worked with." },
];

export const BLOG_POSTS = [
  {
    slug: "why-car-magnets-matter",
    title: "Your Business on the Move: Why Car Magnets Matter",
    excerpt:
      "Car magnets aren't just decoration — they're one of the most underrated print marketing tools for local businesses. Here's why they pay off in Broward County.",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/blog-car-magnets.png`,
    date: "Mar 12, 2026",
    readTime: "5 min read",
    author: "Let’s Print Team",
    category: "Marketing",
    related: ["car-magnets", "regular-business-card", "flyers"],
    body: [
      { type: "lead", text: "Car magnets aren't just a flashy way to dress up your ride — they're one of the most underrated yet powerful print marketing tools for local businesses. In Broward County, where the roads are always buzzing, a branded vehicle becomes a mobile billboard that turns every commute into a marketing opportunity." },
      { type: "p", text: "Let's break down why car magnets matter and how they can drive visibility, trust, and ROI for your business." },

      { type: "h2", text: "Mobile exposure means more eyeballs on your brand" },
      { type: "p", text: "You can't scroll past a moving car the way you scroll past ads online. Vehicle signage generates anywhere from 30,000 to 70,000 daily impressions depending on location and frequency of travel. In busy areas like Fort Lauderdale or Hollywood FL, that number climbs fast." },
      { type: "p", text: "Car magnets give your brand instant visibility in your local community — from drive-thrus and parking lots to events and traffic jams." },
      { type: "ul", items: [
        "Promotes your business while you're already on the move",
        "Captures attention without being invasive",
        "Works 24/7 — no screen time needed",
        "No recurring costs like digital ads",
      ]},

      { type: "h2", text: "🧲 Easy to use, remove, and reuse" },
      { type: "p", text: "Unlike vehicle wraps or permanent decals, magnets are a stress-free option. They're ideal for small businesses, freelancers, or anyone who uses their vehicle for both personal and business purposes. Slap them on during work hours and remove them when you're off duty — no harm, no fuss." },
      { type: "p", text: "Why Broward County businesses love magnets:" },
      { type: "ul", items: [
        "Weather-resistant and long-lasting, even in Florida humidity",
        "Reusable for seasonal promos or rotating offers",
        "Great for rideshare drivers, realtors, and cleaning services",
        "No damage to your car paint or finish",
      ]},

      { type: "h2", text: "🎯 Builds brand trust locally" },
      { type: "p", text: "In neighborhoods like Pembroke Pines, Coral Springs, or Weston, familiarity breeds trust. When people see your branded vehicle around town consistently, it sends a strong message — you're local, established, and reliable." },
      { type: "callout", emoji: "📊", text: "Low-key repetition matters: 84% of consumers say they're more likely to buy from brands they recognize." },
      { type: "p", text: "Whether you're delivering flyers, offering services, or showing up for an event, a branded vehicle magnet shows you mean business." },
      { type: "h3", text: "Quick tips" },
      { type: "ul", items: [
        "Include your logo, tagline, and contact info",
        "Keep the design bold but simple for easy reading",
        "Use colors consistent with your brand identity",
      ]},

      { type: "h2", text: "💡 Small investment, big marketing win" },
      { type: "p", text: "Compared to billboards or online ads, car magnets offer one of the lowest costs per impression in advertising — a budget-friendly choice for Broward County small businesses. If you're running a home service, local shop, mobile grooming, or even a side hustle, a single magnet could land your next big client." },
      { type: "h3", text: "Don't forget" },
      { type: "ul", items: [
        "Bundle with business cards or flyers for added effect",
        "Match your magnet design with your website and social handles",
        "Promote time-sensitive deals with seasonal magnet updates",
      ]},

      { type: "h2", text: "🚀 Hit the road with your brand" },
      { type: "p", text: "Car magnets are simple, smart, and surprisingly effective — especially for small businesses trying to stand out in a busy local market. At Let’s Print, we help businesses across Fort Lauderdale, Miramar, and the rest of Broward County create magnets that not only look great but drive real attention." },
      { type: "p", text: "Need help designing one that pops on the road? From layout to delivery, we've got your back." },
      { type: "cta", text: "Design your custom car magnet", to: "/product/car-magnets" },
    ],
  },
  {
    slug: "15-sticker-designs-to-boost-your-broward-brand",
    title: "15 Sticker Designs to Boost Your Broward Brand",
    excerpt:
      "Stickers aren't just fun — they're powerful little marketing tools that turn any surface into a mini billboard. Here are 15 ideas with serious Broward flavor.",
    image: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/categories/blog-stickers-broward.png`,
    date: "Feb 22, 2026",
    readTime: "6 min read",
    author: "Let’s Print Team",
    category: "Inspiration",
    related: ["waterproof-vinyl-labels", "standard-labels", "flyers"],
    body: [
      { type: "lead", text: "Stickers aren't just fun — they're powerful little marketing tools that can turn any surface into a mini billboard. Whether you're a small café in Fort Lauderdale, a boutique in Pembroke Pines, or a creator hustling out of Hollywood, FL — custom stickers can give your brand some serious Broward flavor." },

      { type: "h2", text: "Why stickers work for small businesses" },
      { type: "p", text: "Think of stickers as low-cost, high-impact assets. They're portable, visual, and they can make your brand travel places — on water bottles, laptops, delivery bags, and more. Plus, customers love them. Hand someone a free sticker and watch how quickly they become a brand ambassador." },
      { type: "p", text: "Especially in Broward County, where local pride runs deep, a well-designed sticker can strike the right emotional chord with the right audience." },

      { type: "h2", text: "15 designs to show off your Broward vibes" },
      { type: "p", text: "Here's a mix of modern, fun, and locally inspired sticker ideas to spark your next batch." },
      { type: "ul", items: [
        "\"Thank You, Broward!\" — perfect for packaging.",
        "\"Made in South Florida\" — add it to every product or craft.",
        "\"Fort Lauderdale Vibes\" — with palm trees, of course.",
        "\"Support Local — Broward Edition\"",
        "\"Pembroke Pines Proud\" — a nod to the home crowd.",
        "\"Plant Lover, Beach Soul\" — for your earthy customers.",
        "\"Shipped With Sunshine\" — for online orders.",
        "\"You Matter, You Broward Star!\" — motivation in sticker form.",
        "\"Eat Local, Print Local\" — perfect for food trucks and vendors.",
        "\"Weekend Vibes Only — FTL Edition\"",
        "\"Small Business, Big Dreams\"",
        "\"Let’s Print Delivers\" — our signature one 😉",
        "\"Shop Small, Shine Bright\"",
        "\"You Had Me at Hola — South Florida Style\"",
        "\"Built in Broward\" — a proud label for local makers.",
      ]},

      { type: "h2", text: "How to use these stickers (and make 'em pop)" },
      { type: "ul", items: [
        "Customer freebies — toss one in every delivery bag or thank-you note.",
        "Event giveaways — perfect for booths, summer fairs, and pop-ups.",
        "Branded packaging — seal your product with flair.",
        "Summer camps & schools — kids love a cool sticker moment.",
        "Laptops, bikes, water bottles — your brand, traveling with your people.",
      ]},

      { type: "h2", text: "💡 Ready to go pro? Let Let’s Print help" },
      { type: "p", text: "When you're ready to take it to the next level, here's how we can help:" },
      { type: "ul", items: [
        "Custom die-cut stickers — any shape, any size.",
        "Gloss or matte finish — pick the vibe.",
        "Outdoor-grade vinyl — weatherproof and beach-proof.",
        "Roll stickers — perfect for mass labeling and promo use.",
        "Quick delivery in Broward — because we're just around the corner.",
      ]},
      { type: "p", text: "We can also match your stickers with your full brand identity — logos, business cards, flyers, you name it." },
      { type: "cta", text: "Design your sticker pack", to: "/product/waterproof-vinyl-labels" },
    ],
  },
  {
    slug: "3-simple-branding-tips-for-small-businesses",
    title: "3 Simple Branding Tips for Small Businesses",
    excerpt:
      "Stand out, stay remembered, and grow stronger — your brand deserves it. Three practical branding moves you can make this week.",
    image: "https://images.unsplash.com/photo-1606857521015-7f9fcf423740?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    date: "Jan 30, 2026",
    readTime: "5 min read",
    author: "Let’s Print Team",
    category: "Branding",
    related: ["regular-business-card", "flyers", "waterproof-vinyl-labels"],
    body: [
      { type: "lead", text: "Stand out, stay remembered, and grow stronger — your brand deserves it." },

      { type: "h2", text: "Why branding is a big deal (even for the smallest businesses)" },
      { type: "p", text: "If you're a small business owner in Broward County — whether you're running a cozy coffee shop in Fort Lauderdale or a handmade soap studio in Hollywood — your brand is your first impression. It's what makes people trust you, remember you, and come back for more." },
      { type: "p", text: "Branding isn't just about your logo — it's how you sound, how you look, and how you make people feel. And with competition growing across Pembroke Pines, Coral Springs, and beyond, your brand needs to show up strong and consistent." },
      { type: "p", text: "Here are three simple, practical branding moves every small business can start using today." },

      { type: "h2", text: "🎯 1. Define your brand personality (before you design anything)" },
      { type: "p", text: "Before you choose colors, fonts, or logo shapes, take a minute to ask yourself: what do I want people to feel when they see my brand? Are you playful and creative, or bold and professional? Knowing this sets the tone for everything that follows." },
      { type: "h3", text: "Try this" },
      { type: "ul", items: [
        "Pick three words that describe your brand (e.g. \"friendly, modern, bold\").",
        "Check whether your current logo, website, or packaging matches that vibe.",
        "Align visuals, messaging, and tone to reflect that personality everywhere — from your flyers to your social media captions.",
      ]},
      { type: "callout", emoji: "🧠", text: "Consistent brand presentation across platforms can increase revenue by up to 23% (Lucidpress)." },

      { type: "h2", text: "🎨 2. Keep your visual identity consistent" },
      { type: "p", text: "You don't need a full rebrand to look polished — you just need consistency. Whether you're printing business cards or running a Facebook ad, your brand should look and feel the same everywhere." },
      { type: "p", text: "Let’s Print can help you create a visual brand kit that includes:" },
      { type: "ul", items: [
        "Fonts and color palettes",
        "Logo versions for different backgrounds",
        "Social media templates",
        "Print-ready designs that match your online branding",
      ]},
      { type: "p", text: "In cities like Davie and Miramar, where local recognition matters, cohesive branding helps people spot your business instantly — on signs, stickers, or even a printed tote bag." },

      { type: "h2", text: "🤝 3. Use printed materials to strengthen brand recall" },
      { type: "p", text: "Digital is great, but there's something about print that sticks — literally. Branded materials like flyers, thank-you cards, and packaging inserts help customers remember you long after a scroll ends." },
      { type: "h3", text: "Smart print moves" },
      { type: "ul", items: [
        "Add a branded QR code on every flyer or card.",
        "Use custom stickers with your logo for packaging.",
        "Hand out loyalty cards or referral cards that look like they belong to your brand family.",
      ]},
      { type: "callout", emoji: "📌", text: "Studies show people are 70% more likely to remember a brand seen in print versus online alone — don't skip the tangible touchpoints." },

      { type: "h2", text: "💬 Let's make your brand unforgettable" },
      { type: "p", text: "Branding doesn't have to be overwhelming. With a few thoughtful choices, you can build a brand that feels real, relatable, and ready to grow. From Coral Springs to Plantation, Broward businesses are showing up stronger than ever — and yours can too." },
      { type: "p", text: "At Let’s Print, we make your brand look as good as it feels — through smart design, high-quality printing, and a team that gets small businesses." },
      { type: "cta", text: "Get branding support", to: "/contact?service=website-development" },
    ],
  },
];

export function getBlogPostBySlug(slug) {
  return BLOG_POSTS.find((p) => p.slug === slug);
}

export const BRAND_LOGOS = [
  {
    name: "The UPS Store",
    logo: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/svu8ibo6_image.png",
  },
  {
    name: "Broward Health",
    logo: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/2dav0l6l_image.png",
  },
  {
    name: "Smoothie King",
    logo: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/if9et5y1_image.png",
  },
  {
    name: "Snappers Fish & Chicken",
    logo: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/fcbheg9h_image.png",
  },
  {
    name: "Crafty Crab",
    logo: "https://customer-assets.emergentagent.com/job_custom-print-flow/artifacts/a0zmiibp_image.png",
  },
];

export function getProductsByCategory(slug) {
  return PRODUCTS.filter((p) => p.category === slug);
}

export function getProductBySlug(slug) {
  return PRODUCTS.find((p) => p.slug === slug);
}

export function getCategoryBySlug(slug) {
  return NAV_CATEGORIES.find((c) => c.slug === slug);
}

// Business-card-specific copy & content
export const BC_FAQS = [
  {
    q: "What sizes are available for Let’s Print business cards?",
    a: "We currently offer two sizes — Standard (2.0\" × 3.5\") and Square (2.56\" × 2.56\"). Standard fits most wallets and cardholders; Square stands out in a stack.",
  },
  {
    q: "How long until my cards arrive?",
    a: "Most orders are printed and shipped within 5–6 business days. Local South Florida orders qualify for express pickup in 1–2 business days if placed before 2 PM EST.",
  },
  {
    q: "What's the difference between matte and gloss finish?",
    a: "Matte gives you a smooth, glare-free surface with a softer feel — great for typography-heavy designs. Gloss adds a reflective shine that makes photos and bold colors really come alive.",
  },
  {
    q: "Are Let’s Print cards printed on both sides?",
    a: "Yes. Every card we print includes full-color, double-sided printing at no extra cost. Use the back for a tagline, social handle, QR code, or a different design entirely.",
  },
  {
    q: "Can I get help designing my cards?",
    a: "Absolutely. Pick the 'Let’s Print will design it for me' option at checkout and our in-house team will create a layout from your logo and brand assets. Two rounds of revisions included.",
  },
  {
    q: "Do you offer bulk pricing?",
    a: "Yes — the larger the run, the lower the cost per card. Pricing scales automatically when you pick a higher quantity tier. For runs above 5,000 cards, contact us for a custom quote.",
  },
  {
    id: "reprint-promise",
    q: "What is your Reprint Promise?",
    a: "We back our work with a strict Reprint Promise. If you contact us and send a photo within 5 days of delivery, we will happily reprint your order — no questions asked — if:\n• It's damaged: The items arrived bent, torn, or damaged in transit.\n• It's a production error: The final print does not match the artwork you approved or uploaded.\n\nNote: Our promise does not cover blurriness or low-quality issues resulting from low-resolution files provided or approved by the customer.",
  },
  {
    q: "What file format should I upload?",
    a: "Print-ready PDFs are best, but we also accept high-resolution PNG, JPG, AI and PSD files. Make sure your design includes 0.125\" bleed on all sides at 300dpi.",
  },
];

export const BC_INSPIRATION = [
  { id: 1, image: "https://images.unsplash.com/photo-1599590984817-0c15f31b1fa5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", title: "Minimal & confident" },
  { id: 2, image: "https://images.unsplash.com/photo-1605098293544-25f4c32344c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", title: "Bold typography" },
  { id: 3, image: "https://images.unsplash.com/photo-1718670013921-2f144aba173a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", title: "Architectural lines" },
  { id: 4, image: "https://images.pexels.com/photos/7318941/pexels-photo-7318941.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", title: "Layered & textured" },
  { id: 5, image: "https://images.unsplash.com/photo-1559056199-96c307526265?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", title: "Color blocks" },
  { id: 6, image: "https://images.unsplash.com/photo-1633296453613-94b169c2e525?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", title: "Editorial moodboard" },
];

export const BC_GUIDELINES = [
  {
    id: "standard",
    label: "Standard",
    bleed: '3.75″ × 2.25″',
    trim: '3.5″ × 2.0″',
    safe: '3.34″ × 1.84″',
    pixels: "1098 × 648 px @ 300 dpi",
  },
  {
    id: "square",
    label: "Square",
    bleed: '2.81″ × 2.81″',
    trim: '2.56″ × 2.56″',
    safe: '2.4″ × 2.4″',
    pixels: "813 × 813 px @ 300 dpi",
  },
];

// Active promo codes — used by checkout for validation
// Future: managed via a CMS / admin tool, listed on /promo
export const PROMO_CODES = [
  {
    code: "LETSPRINT20",
    label: "20% off your first Let’s Print order",
    discountType: "percent",
    value: 20,
    minOrder: 40,
    description: "First-time customers only. Valid on orders of $40+. Excludes shipping & gift cards.",
  },
  {
    code: "BC10",
    label: "$10 off any Business Cards order",
    discountType: "flat",
    value: 10,
    minOrder: 50,
    description: "Save $10 on business card orders of $50 or more.",
  },
  {
    code: "WELCOME10",
    label: "10% off site-wide",
    discountType: "percent",
    value: 10,
    minOrder: 25,
    description: "10% off any order over $25. Can't be combined with other offers.",
  },
];
